import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import flatpickr from "flatpickr";
import Swiper from 'swiper/bundle';
import { German } from "flatpickr/dist/l10n/de.js";
import TariffRenderer from './tariff-renderer.es6';

// Selectors
const SELECTORS = {
    ALL_INPUTS: '.ninja-forms-field:not(.select2-hidden-accessible)',
    FIELD_CONTAINER: '.nf-field-container',
    NINJA_FORMS_FIELD: '.ninja-forms-field',
    DATE_PICKER: '.date-container .datepicker',
    DATE_PICKER_14: '.date-container .datepicker[name="supplyEndDate"]',
    DATE_PICKER_1: '.date-container .datepicker[name="supplyBeginDate"]',
    DATE_LABEL: '.date-container label',
    DATE_ICON: '.date-icon',
    DATE_INPUT: '.date-container .input',
    ABLESEDATUM_INPUT: '[name="ablesedatum"]',
    METER_READING_INPUT: '[name="meterReading"]',
    METER_READING_HT_INPUT: '[name="meterReadingHT"]',
    METER_READING_NT_INPUT: '[name="meterReadingNT"]',
    SWITCHER_RADIO: '.trigger-fields input',
    SWITCHER_RADIO_CHECKED: '.switcher-container input:checked',
    FORM: '#umzug-form',
    FORM_CONTAINER: '.form-box',
    FORM_WRAPPER: '.umzug_form .wrapper',
    POPUP_WRAPPER: '.umzug_form .popup-wrapper',
    LOADER: '#loader',
    RESPONSE_ERRORS: '.response-errors',
    SUBMIT_BUTTON: '[type="submit"]',
    STEP4_TABLE_TOTAL: '#step4TableTotalPrice',

    CONSUMPTION_INPUT:     '[name="consumption"]',
    STREET_INPUT_FAKE:     '[name="street_fake"]',       // adjust if your name differs
    HOUSE_NUMBER_INPUT_FAKE:'[name="housenumber_fake"]', // adjust if your name differs
    PRICE_INFO_CONTAINER:  '.price-info-container',

    BANK_ACCOUNT_OWNER_NAME: '[name="bankAccountOwnerName"]',
    BANK_ACCOUNT_IBAN_INPUT: '[name="bankAccountIban"]',
    BANK_NAME_INPUT:         '[name="bankName"]',
    ERROR_NAME_BANK:         '.error-name-bank',
    CONTAINER_BANK_NAME:     '.bank-name-container',
    PAYMENT_TYPE_RADIO:      'input[name="paymentType"]',
    PAYMENT_TYPE_RADIO_CHECKED: 'input[name="paymentType"]:checked',

    NEXT_BUTTONS: '.button-next',
    PREV_LINKS: '.back-link-wrap a.btn-step-back',

    STEPS_TEXT: '.multistep-header .steps-text',
    STEP_TITLE: '.multistep-header .header-title',
    APPROVE_EMAIL_NOTIFICATION: 'input[name="approveEmailNotification"]',
    MARKET_LOCATION_INPUT: 'input[name="marketLocation"]',

    PROMOCODE_CONTAINER: '.promocode-container',
    PROMOCODE_WRAP: '.promocode-wrap',
    PROMOCODE_INPUT: '[name="promocode"]',
    PROMOCODE_BUTTON: '.promocode-button',
    PROMOCODE_SUCCESS: '.promocode-success',

    METER_NUMBER_CHECKBOX: 'input[name="meterNumberCheckbox"]',

    STEP_SLIDES:            '.multistep-slider .slide',
    STEP2_SLIDE:            '.multistep-slider .slide:nth-child(2)',
    STEP3_SLIDE:            '.multistep-slider .slide:nth-child(3)',
    STEP3_COLLAPSED_FORM:   '.collapsed-data .form-fields',
    API_ERROR_MESSAGE:   '.api-error-message',
};

const SWIPER = {
    CONTAINER: '.multistep-slider.swiper-container'
};

// --- Transforms registry (central place to tweak logic) ---
const TRANSFORMS = {
    number: (v) => {
        if (v == null || v === '') return v;
        const n = Number(v);
        return Number.isNaN(n) ? v : n;
    },
    iban: (v) => String(v).replace(/\s+/g, '').replace(/_/g, '').toUpperCase(),
    deDateToISO: (v) => {
        const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(v).trim());
        if (m) return new Date(`${m[3]}-${m[2]}-${m[1]}T00:00:00Z`).toISOString();
        // pass-through if already ISO / unknown
        return v;
    },
    dob: (v) => {
        const s = String(v);
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return new Date(s).toISOString();
        if (/^\d{10,13}$/.test(s)) return (new Date(parseInt(s,10))).toISOString();
        return s;
    },
    digitsOnly: (v) => {
        if (v == null || v === '') return v;
        const n = Number(String(v).replace(/[^\d]/g, ''));
        return Number.isFinite(n) ? n : undefined;
    }
};

// --- Sources resolver (form/url/internal/contract) ---
const READERS = {
    url: (svc, row) => (svc.urlParams || {})[row.from],
    internal: (svc, row) => svc[row.from],
    contract: (svc, row) => svc._getFromContract(row.from),
    form: (svc, row) => {
        const sel = row.selector || `[name="${row.from}"]`;
        const $el = $(sel);
        if (!$el.length) return undefined;
        const $first = $el.eq(0);
        if ($first.is(':radio'))   return $(`${sel}:checked`).val();
        if ($first.is(':checkbox'))return $first.is(':checked') ? 'true' : 'false';
        const v = $first.val();
        return Array.isArray(v) ? v.join(',') : v;
    }
};

// helper for dot-path set
function setDeep(target, path, value) {
    if (value == null) return;
    const parts = String(path).split('.');
    let obj = target;
    while (parts.length > 1) {
        const k = parts.shift();
        if (!(k in obj) || typeof obj[k] !== 'object') obj[k] = {};
        obj = obj[k];
    }
    obj[parts[0]] = value;
}

// --- Mapping config: what to collect and from where ---
// Keep your FIELD_MAP as-is; below I only ensure transforms are named like in TRANSFORMS
const FIELD_MAP = [
    // Dates from form (ти вже це використовуєш)
    { to: 'supply.beginDate', from: 'supplyBeginDate', source: 'form', selector: '[name="supplyBeginDate"]', transform: 'deDateToISO', optional: true },
    { to: 'supply.endDate',   from: 'supplyEndDate',   source: 'form', selector: '[name="supplyEndDate"]',   transform: 'deDateToISO', optional: true },
];

// Replace your constant REQUIRED_URL_PARAMS with:
const REQUIRED_URL_PARAMS = ['postalcode','city','consumption','housenumber','street'];

// Computed rows that depend on multiple inputs (e.g., rateType / meter readings)
const FIELD_COMPUTED = [
    {
        // single vs double rate readings
        compute: (svc) => {
            const rate = $(`input[name="rateType"]:checked`).val() || $(`input[name="rateType"]`).val() || '';
            const result = {};
            const asDigits = (sel) => TRANSFORMS.digitsOnly($(sel).val());
            if (rate === 'singleRate') {
                const v = asDigits(SELECTORS.METER_READING_INPUT);
                if (v != null) result['reading.meterReading'] = v;
            } else if (rate === 'doubleRate') {
                const ht = asDigits(SELECTORS.METER_READING_HT_INPUT);
                const nt = asDigits(SELECTORS.METER_READING_NT_INPUT);
                if (ht != null) result['reading.meterReadingHT'] = ht;
                if (nt != null) result['reading.meterReadingNT'] = nt;
            }
            return result;
        }
    }
];


class UmzugApiService {
    constructor() {
        this._loading = false; // Internal loading state
        this.onLoadingChange = null; // Callback for loading state changes
        // Absolute path (from myajax, localized in functions.php via get_stylesheet_directory_uri())
        // rather than a relative "../" path - a relative path breaks once the current URL is
        // nested more than one segment deep, since "../" only pops a single path segment
        // instead of resolving back to the site root.
        this.proxyUrl = (typeof myajax !== 'undefined' && myajax.proxy_url) || '../wp-content/themes/gruuun-theme/api-proxi.php';
        this.debounceDelay = 300;
        this.loading = false;

        this._abort = false;
        this.urlParams = this.readUrlParams();

        this.contractNumberValue = this.urlParams.contractNumber || ''; // keep old behavior
        this.businessPartnerNumberValue = '';
        this.contractData = {};
        this.allowedTariffs = [];

        this.chosenTariff = null;
        this.tariffUiById = {};
        // In constructor
        this.defaultFormData = {}; // base snapshot from contract

        // Live bank overrides (filled by IBAN checker; do NOT touch defaults here)
        this.bankName = '';
        this.bankAccountBic = '';
        this.bankAccountIban = '';
        this.couponCode = null;
        this.couponArt = null;
        this.couponValue = null;

        this.forceAdvertisingConsentTrue = false;

        this._mirrorLock = false;
        this.wasSendToApi = false;
        this.defaultConsumption = 2500;

        this.renderForm();
        this.initializeEventListeners();

        // Enable live mirroring between step 2 and step 3
        this.bindThirdStepMirroring();
    }

    // Getter for loading state
    get loading() {
        return this._loading;
    }

    // Setter for loading state with additional logic
    set loading(value) {
        if (this._loading !== value) {
            this._loading = value;
            // Trigger callback if defined
            if (typeof this.onLoadingChange === "function") {
                this.onLoadingChange(value);
            }
        }
    }

    readUrlParams() {
        const sp = new URLSearchParams(window.location.search);

        const params = {
            contractNumber: sp.get('contractNumber') || '',
            postalcode:     sp.get('postalcode') || '',
            city:           sp.get('city') || '',
            consumption:    sp.get('consumption') || '',
            housenumber:    sp.get('housenumber') || '',
            street:         sp.get('street') || '',
            housenumberAdditional: sp.get('housenumberAdditional') || ''
        };

        Object.keys(params).forEach(k => {
            if (typeof params[k] === 'string') params[k] = params[k].trim();
        });

        return params;
    }

    _sanitizeForDisplay(v) {
        if (v == null) return '';
        return String(v).replace(/<[^>]*>/g, '').trim();
    }

    // ---- SUMMARY helpers ----

    _enterMirror() { this._mirrorLock = true; }
    _exitMirror()  { this._mirrorLock = false; }
    _isMirroring() { return this._mirrorLock === true; }

    // Map for salutation labels
    _salutationLabel(code) {
        const map = { '2':'Herr', '1':'Frau', '3':'Familie', '5':'Divers' };
        return map[String(code)] || '';
    }

    // Parse dot path like "a.b.c" from an object safely
    _getByPath(obj, path) {
        if (!obj || !path) return undefined;
        const parts = String(path).split('.');
        let cur = obj;
        for (const p of parts) {
            if (cur == null) return undefined;
            cur = cur[p];
        }
        return cur;
    }

    // Format date to dd.mm.yyyy; accepts 'dd.mm.yyyy' or ISO or epoch
    _formatDateToDE(v) {
        if (!v) return '';
        const s = String(v).trim();

        // already de-format
        const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(s);
        if (m) return s;

        // epoch
        if (/^\d{10,13}$/.test(s)) {
            const d = new Date(parseInt(s, 10));
            if (isNaN(d)) return '';
            const dd = String(d.getDate()).padStart(2,'0');
            const mm = String(d.getMonth()+1).padStart(2,'0');
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
        }

        // ISO
        const d = new Date(s);
        if (isNaN(d)) return '';
        const dd = String(d.getDate()).padStart(2,'0');
        const mm = String(d.getMonth()+1).padStart(2,'0');
        const yyyy = d.getFullYear();
        return `${dd}.${mm}.${yyyy}`;
    }

    // Try to resolve summary value by "key":
    // 1) exact input/select by name
    // 2) from defaultFormData (dot path)
    // 3) from computed maps (customer/address)
    // 4) from contractData (dot path)
    _resolveSummaryValue(key) {
        // 1) by form name
        const $inputs = $(`input[name="${key}"], select[name="${key}"], textarea[name="${key}"]`);
        if ($inputs.length) {
            const $first = $inputs.eq(0);
            if ($first.is(':radio')) {
                const v = $(`input[name="${key}"]:checked`).val();
                if (v != null) return v;
            } else if ($first.is(':checkbox')) {
                return $inputs.is(':checked') ? 'true' : 'false';
            } else {
                const raw = $first.val();
                return Array.isArray(raw) ? raw.join(',') : (raw ?? '');
            }
        }

        // 2) from defaults (dot path)
        const fromDefaults = this._getByPath(this.defaultFormData, key);
        if (fromDefaults != null && fromDefaults !== '') return fromDefaults;

        // 3) from computed field maps we already use for summary
        const custMap = this.getCustomerFieldMap ? this.getCustomerFieldMap() : {};
        const addrMap = this.getAddressFieldMap ? this.getAddressFieldMap() : {};
        if (Object.prototype.hasOwnProperty.call(custMap, key)) return custMap[key];
        if (Object.prototype.hasOwnProperty.call(addrMap, key)) return addrMap[key];

        // 4) raw from contract (dot path)
        const fromContract = this._getFromContract?.(key);
        if (fromContract != null && fromContract !== '') return fromContract;

        return '';
    }

    // Render a single summary node <... data-summary="key">
    _renderSummaryNode($el, key) {
        let value = this._resolveSummaryValue(key);

        // Special cases matching your legacy logic
        switch (key) {
            case 'customer.salutation':
            case 'deviatingCustomer.salutation':
                value = this._salutationLabel(value);
                break;

            case 'customer.dateOfBirth':
            case 'supplierOldCancellationDate':
            case 'supplyBeginDate':
            case 'supplyEndDate':
                value = this._formatDateToDE(value);
                break;
        }

        const safe = this._sanitizeForDisplay(value);
        $el.html(safe ? `<b>${safe}</b>` : '');
    }

    // Update all nodes having [data-summary]
    updateSummaryAll() {
        $('[data-summary]').each((_, node) => {
            const $el = $(node);
            const key = $el.data('summary'); // dot path or input name
            if (!key) return;
            this._renderSummaryNode($el, key);
        });

        // Additionally: [data-input-name="..."] legacy support (optional)
        $('[data-input-name]').each((_, node) => {
            const $el = $(node);
            const name = $el.data('input-name');
            if (!name) return;
            const val = $(`input[name="${name}"]`).val();
            const safe = this._sanitizeForDisplay(val);
            $el.html(safe ? `<b>${safe}</b>` : '');
        });
    }

    // Update only nodes bound to a specific input name (called on input change)
    updateSummaryForName(name) {
        if (!name) return;
        $(`[data-summary="${name}"]`).each((_, node) => {
            this._renderSummaryNode($(node), name);
        });

        // If this is a "-copy" field – mirror also original and copy variants
        if (name.endsWith('-copy')) {
            const orig = name.replace(/-copy$/, '');
            $(`[data-summary="${orig}"]`).each((_, node) => {
                this._renderSummaryNode($(node), orig);
            });
        } else {
            const copy = `${name}-copy`;
            $(`[data-summary="${copy}"]`).each((_, node) => {
                this._renderSummaryNode($(node), copy);
            });
        }
    }

    // Returns ISO date with midnight and 'Z'
    _toISODateZ(d) {
        if (!d) return '';
        const date = new Date(d);
        if (isNaN(date)) return '';
        // normalize to 00:00:00Z (UTC)
        date.setUTCHours(0,0,0,0);
        return date.toISOString();
    }

    // Accepts 'dd.mm.yyyy' or ISO -> returns ISO '...T00:00:00.000Z'
    _toISOFromDeOrIso(v) {
        if (!v) return '';
        const s = String(v).trim();
        const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(s);
        if (m) {
            const iso = new Date(`${m[3]}-${m[2]}-${m[1]}T00:00:00Z`);
            return isNaN(iso) ? '' : iso.toISOString();
        }
        // try ISO straight
        return this._toISODateZ(s);
    }

    // Pulls Matomo/GA ids and formats "matomo, ga"
    _getCookieIds() {
        const all = document.cookie.split('; ').filter(Boolean);
        const matomoRow = all.find(r => /^_pk_id[^=]*=/.test(r));
        const googleRow = all.find(r => r.startsWith('_ga='));
        const matomoId = matomoRow ? matomoRow.split('=')[1] : '';
        const googleId = googleRow ? googleRow.split('=')[1] : '';
        if (matomoId || googleId) return `${matomoId}, ${googleId}`;
        return '';
    }

    // Safe getter from contract by path (you already have _getFromContract)
    _getFromContractSafe(path) {
        const v = this._getFromContract(path);
        return (v == null || v === '') ? '' : v;
    }

    // --- Utils for mapping ---

    _getFromContract(path) {
        // Supports 'business.x', 'business.arr[0].y', fallbacks with '||'
        const tryGet = p => {
            if (!this.contractData) return undefined;
            const root = this.contractData;
            if (!p) return undefined;
            const tokens = p.replace(/\[(\d+)\]/g, '.$1').split('.');
            let cur = root;
            for (const t of tokens) {
                if (cur == null) return undefined;
                cur = cur[t];
            }
            return cur;
        };
        if (path.includes('||')) {
            for (const variant of path.split('||')) {
                const v = tryGet(variant.trim());
                if (v != null && v !== '') return v;
            }
            return undefined;
        }
        return tryGet(path);
    }

    _getFormValueBySelector(sel) {
        const $el = $(sel);
        if (!$el.length) return undefined;
        const $first = $el.eq(0);
        if ($first.is(':radio')) {
            return $(`${sel}:checked`).val();
        }
        if ($first.is(':checkbox')) {
            return $first.is(':checked') ? 'true' : 'false';
        }
        const v = $first.val();
        if (Array.isArray(v)) return v.join(',');
        return v;
    }

    // Build payload from FIELD_MAP and current UI state
    _buildPayloadFromMap() {
        const payload = {};
        const read = (row) => {
            // Multiple fallbacks in 'from' using '||'
            if (String(row.from).includes('||') && row.source === 'contract') {
                const variants = row.from.split('||').map(s => s.trim());
                for (const v of variants) {
                    const tmp = this._getFromContract(v);
                    if (tmp != null && tmp !== '') return tmp;
                }
                return undefined;
            }
            const fn = READERS[row.source];
            return fn ? fn(this, row) : undefined;
        };

        // 1) Map simple rows
        for (const row of FIELD_MAP) {
            let value = read(row);

            if ((value == null || value === '') && row.optional) continue;

            if (row.transform && TRANSFORMS[row.transform]) {
                value = TRANSFORMS[row.transform](value);
            }
            if (value != null && value !== '') {
                setDeep(payload, row.to, value);
            }
        }

        // 2) Apply computed rows (can set multiple dot-paths per compute result)
        for (const comp of FIELD_COMPUTED) {
            const block = comp.compute?.(this);
            if (block && typeof block === 'object') {
                Object.entries(block).forEach(([to, v]) => {
                    if (v != null && v !== '') setDeep(payload, to, v);
                });
            }
        }

        return payload;
    }

    // Builds deliveryPointAddress from URL params
    _buildDeliveryPointAddress() {
        const p = this.urlParams || {};
        const addr = {
            city: p.city || '',
            housenumber: p.housenumber || '',
            postalCode: p.postalcode || '',
            street: p.street || ''
        };
        // append housenumberAdditional with space
        if (p.housenumberAdditional) {
            addr.housenumber += String(p.housenumberAdditional);
        }
        return addr;
    }

    // Builds customer block (merging your contract data + legalForm)
    _buildCustomer() {
        const map = this.getCustomerFieldMap ? this.getCustomerFieldMap() : {};
        // map has pretty labels (Herr/Frau). We need raw "salutation": "2" as in your current payload.
        // You already keep raw salutation in contract.business.salutation:
        const salRaw = String(this._getFromContractSafe('business.salutation') || '');
        return {
            salutation: salRaw || (this.urlParams?.salutation || ''), // fallback if needed
            firstname: this._getFromContractSafe('business.firstName') || '',
            lastname:  this._getFromContractSafe('business.name') || '',
            email:     (this._getFromContractSafe('business.newEmail') || this._getFromContractSafe('business.email') || ''),
            phoneNumber: (this._getFromContractSafe('business.phoneNumber') || this._getFromContractSafe('business.phoneNumbers.0.number') || ''),
            dateOfBirth: (() => {
                // Prefer ISO in contract, else epoch
                const iso = this._getFromContractSafe('business.dateOfBirth');
                const epoch = this._getFromContractSafe('business.originalDateOfBirth');
                return iso ? this._toISODateZ(iso) : this._toISODateZ(epoch);
            })(),
            legalForm: '1' // per your old rule
        };
    }

    // Always set bank fields on root: prefer new form values when:
    // paymentType === 'sepaLastschrift' && !keepPaymentMethod
    // else try to copy from contract (if present).
    _buildBankingOnRoot(payload) {
        const paymentType = $(SELECTORS.PAYMENT_TYPE_RADIO_CHECKED).val();
        const keep = $('input[name="keepPaymentMethod"]').is(':checked');

        // Contract defaults (already seeded into defaultFormData and later merged)
        const cOwner = this._getFromContractSafe('business.bankData.accountHolder');
        const cIban  = (this._getFromContractSafe('business.bankData.iban') || '').replace(/\s+/g, '').toUpperCase();
        const cBank  = this._getFromContractSafe('business.bankData.bankName');
        const cBic   = this._getFromContractSafe('business.bankData.bic');

        // Live values from IBAN checker (NOT stored in defaults)
        const liveOwner = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME).val() || '';
        const liveIban  = (this.bankAccountIban || '').toUpperCase();
        const liveBank  = this.bankName || '';
        const liveBic   = this.bankAccountBic || '';

        // Fallbacks from form (if user typed manually without checker)
        const formIban  = (($(SELECTORS.BANK_ACCOUNT_IBAN_INPUT).val() || '').replace(/\s+/g, '')).toUpperCase();
        const formBank  = $(SELECTORS.BANK_NAME_INPUT).val() || '';
        const formOwner = liveOwner;

        // Decision:
        // - If SEPA and NOT keepPaymentMethod => prefer live checker values; fallback to manual form if no live
        // - Else => prefer contract (do not use the live values)
        let owner='', iban='', bank='', bic='';

        if (paymentType === 'sepaLastschrift' && !keep) {
            owner = liveOwner || formOwner;
            iban  = liveIban  || formIban;
            bank  = liveBank  || formBank;
            bic   = liveBic   || ''; // BIC only from checker (no manual field)
        } else {
            owner = cOwner;
            iban  = cIban;
            bank  = cBank;
            bic   = cBic;
        }

        if (owner) payload.bankAccountOwnerName = owner;
        if (iban)  payload.bankAccountIban = iban;
        if (bank)  payload.bankName = bank;
        if (bic)   payload.bankAccountBic = bic;
    }

    // Build flags and ancillary fields based on UI (old rules)
    _enrichWithOldRules(payload) {
        // Section and simple defaults
        payload.section = 'Electricity';

        // Consumption and tariff
        const consumption = Number(this.urlParams?.consumption || 0) || 0;
        payload.consumptionPrognosisKwh = String(consumption || this.defaultConsumption || '');

        // tarifId: string
        if (this.chosenTariff) {
            payload.tarifId = String(this.chosenTariff);
        }

        payload.supplyBeginDateSpecified = true;
        payload.oldSupplier = '';
        payload.supplyChangeCause = 'move';

        payload.booleanAdditional3 = true;

        // Cookies id
        const ids = this._getCookieIds();
        if (ids) payload.stringAdditional2 = ids;

        // Coupons / keys (if you use these in your UI)
        if (this.couponCode) {
            payload.listAdditional2 = `${this.couponArt}, ${this.couponValue}`;
        }

        const device = $('[name="deliveryPointMeteringDeviceNumber"]').val() || '';
        if (device) {
            payload.deliveryPointMeteringDeviceNumber = device;
        }

        // Device / market location (only if checkbox enabled)
        if ($(SELECTORS.METER_NUMBER_CHECKBOX).prop('checked')) {
            const market = $(SELECTORS.MARKET_LOCATION_INPUT).val() || '';
            if (market) payload.marketLocation = market;
        }

        // If additional info said consent is already approved, force true and skip UI-based flag
        if (this.forceAdvertisingConsentTrue === true) {
            payload.booleanAdditional2 = true;
        } else {
            // current UI-based behavior (keep your existing code)
            payload.booleanAdditional2 = $(SELECTORS.APPROVE_EMAIL_NOTIFICATION).is(':checked') ? true : false;
        }

        payload.booleanAdditional1 = 'false';

        const v = $('[name="supplyBeginDate"]').val();
        payload.supplyBeginDate = this._toISOFromDeOrIso(v);
        payload.supplyBeginDateSpecified = true;
    }

    initPromocodeHandlers() {
        // Handle click on "Apply promo" button
        $(document).on('click', SELECTORS.PROMOCODE_BUTTON, (e) => {
            e.preventDefault();

            const $container         = $(SELECTORS.PROMOCODE_CONTAINER);
            const $wrap              = $(SELECTORS.PROMOCODE_WRAP);
            const $errorMessage      = $wrap.find('.nf-error-msg');
            const $promocodeSuccess  = $(SELECTORS.PROMOCODE_SUCCESS);
            const $promocodeButton   = $(SELECTORS.PROMOCODE_BUTTON);
            const couponCode         = $(SELECTORS.PROMOCODE_INPUT).val();

            // Reset visual state
            const showError = (msg) => {
                this.couponCode = null;
                this.couponArt  = null;
                this.couponValue= null;
                $container.removeClass('required-label');
                $wrap.addClass('nf-error');
                $promocodeSuccess.remove();
                $errorMessage.html(`<label class="error">${msg}</label>`);
                $promocodeButton.removeClass('loading');
                this.safeUpdateAutoHeight();
            };

            if (!couponCode || !String(couponCode).trim()) {
                // Empty input -> show required
                $container.addClass('required-label');
                $wrap.addClass('nf-error');
                $promocodeSuccess.remove();
                $errorMessage.html('<label class="error">Dieses Feld wird benötigt.</label>');
                return;
            }

            $promocodeButton.addClass('loading');

            $.ajax({
                url:  myajax.url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'verify_coupon',
                    coupon: couponCode,
                    nonce:  myajax.nonces.verify_coupon,
                }
            })
                .done((response) => {
                    if (response && response.success) {
                        // Persist coupon to the service (will be used in payload)
                        this.couponCode  = response.data.code   || couponCode;
                        this.couponArt   = response.data.art    || null;
                        this.couponValue = response.data.value  || null;

                        // Lock UI
                        $container.removeClass('required-label').addClass('blocked');
                        $container.find('input, button').attr('disabled', 'disabled');
                        $wrap.removeClass('nf-error');
                        $errorMessage.html('');

                        // Success message
                        const successHtml = `<div class="text-3">${response.data.success_message || 'Gutschein angewendet.'}</div>`;
                        if ($(SELECTORS.PROMOCODE_SUCCESS).length) {
                            $(SELECTORS.PROMOCODE_SUCCESS).find('.nf-field-element').html(successHtml);
                        } else {
                            $container.after(`
                        <div class="nf-field-container html-container promocode-success -h4-container">
                          <div class="field-wrap html-wrap">
                            <div class="nf-field-element">${successHtml}</div>
                          </div>
                        </div>
                    `);
                        }
                        $promocodeButton.removeClass('loading');
                        this.safeUpdateAutoHeight();

                    } else {
                        // Backend returned error text
                        const msg = (response && response.data) ? response.data : 'Da ist etwas schiefgelaufen';
                        showError(msg);
                    }
                })
                .fail(() => {
                    showError('Da ist etwas schiefgelaufen');
                });
        });
    }

    assertUrlParamsOrAbort(params) {
        const missing = REQUIRED_URL_PARAMS.filter(k => !params[k]);
        if (missing.length) {
            this.hideLoader();
            console.error('Missing URL params:', missing);
            $(SELECTORS.FORM_CONTAINER).html(
                `<div class="page-title error-token">
                <h1>Fehlende Parameter</h1>
                <div class="text-2">
                  <p>Erforderliche Parameter fehlen: <strong>${missing.join(', ')}</strong>.</p>
                  <p>Bitte rufe den Link erneut auf oder kontaktiere den Support.</p>
                </div>
             </div>`
            );
            this._abort = true; // internal flag to stop further flow
            return false;
        }
        return true;
    }

    updateStepLine(stepIndex = 0) {
        const widths = [22.2, 53.3, 65.0];

        const i = Math.max(0, Math.min(stepIndex, widths.length - 1));
        const w = widths[i];

        const $filled = $('.step-line .filled');
        if ($filled.length) {
            $filled.css('width', `${w}%`);
        }
    }


    fetchAllowedTariffs(oldTariffId) {
        // якщо не знаємо старий тариф — просто не обмежуємо результати
        if (!oldTariffId) {
            this.allowedTariffs = [];
            return Promise.resolve([]);
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'get_umzug_allowed_tariffs',
                    nonce:  myajax.nonces.get_umzug_allowed_tariffs, // додай у localize_script
                    tariff_id: String(oldTariffId)
                },
                success: (res) => {
                    if (res && res.success && res.data && Array.isArray(res.data.allowed_tariff_ids)) {
                        this.allowedTariffs = res.data.allowed_tariff_ids.map(String);

                        console.log(this.allowedTariffs);
                        resolve(this.allowedTariffs);
                    } else {
                        // якщо бек нічого не знайшов — не фільтруємо
                        this.allowedTariffs = [];
                        resolve(this.allowedTariffs);
                    }
                },
                error: (xhr, status, err) => {
                    console.error('Allowed tariffs AJAX error:', status, err);
                    this.allowedTariffs = [];
                    resolve(this.allowedTariffs); // не блокуємо пайплайн
                }
            });
        });
    }

    // перевірка валідності поточного слайда
    validateInputsOnSlide(index) {
        const s = this.swiper;
        if (!s || !s.slides || !s.slides[index]) return true;

        const $slide = $(s.slides[index]);
        const $inputs  = $slide.find(':input').not('.select2-hidden-accessible');
        const $selects = $slide.find('select');
        let allValid = true;

        const $form = $(SELECTORS.FORM);

        $inputs.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $containerOfIban = $(this).closest('.listcheckbox-container-box');
            const $wrap = $(this).closest('.field-wrap');
            if(!$containerOfInput.hasClass('required-if-showed') && !$containerOfIban.hasClass('required-if-showed')) {
                $form.validate().element(this);
                if (!this.checkValidity() || $wrap.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        $selects.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            const $wrap = $(this).closest('.field-wrap');
            if(!$containerOfInput.hasClass('required-if-showed')) {
                $form.validate().element(this);
                if (!this.checkValidity() || $wrap.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        return allValid;
    }

    // косметика — підняти лейбли на новому кроці
    checkFieldsOnStep(stepIndex) {
        const step = stepIndex + 1;
        $(`.multistep-slider .slide:nth-child(${step}) .ninja-forms-field:not(.select2-hidden-accessible)`).each(function () {
            const $input = $(this);
            const $container = $input.closest('.nf-field-container');
            if (!$input.is('select') && !$input.is(':checkbox') && !$input.is(':radio')) {
                if (String($input.val() || '').trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
        });
    }

    getPriceInformation(city, postalCode, consumption, street = '', housenumber = '') {
        const requestBody = {
            address: {
                city,
                postalCode
            },
            consumption,
            requestDate: new Date().toISOString(),
            section: "Electricity"
        };
        if (street) {
            requestBody.address.street = street;
            requestBody.address.housenumber = housenumber;
        }

        // return a native Promise so we can use .finally()
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${this.proxyUrl}?type=getPriceInformation`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(requestBody),
                dataType: 'json'
            })
                .done(res => resolve(res))
                .fail((xhr, status, err) => reject(err || status));
        });
    }

    /** Compute and render price info using URL params. Abort on any missing param. */
    preloadPriceInfoFromUrl() {
        if (!this.assertUrlParamsOrAbort(this.urlParams)) {
            return Promise.resolve();
        }

        const { postalcode, city, consumption, street, housenumber, housenumberAdditional } = this.urlParams;
        const consumptionNum = Number(consumption);
        let houseNumStr = String(housenumber);
        if(housenumberAdditional) {
            houseNumStr += String(housenumberAdditional);
        }

        return this.getPriceInformation(city, postalcode, consumptionNum, street, houseNumStr)
            .then(priceInfo => {
                if (typeof this.renderPriceInformation === 'function') {
                    // ВАЖЛИВО: повертаємо проміс, щоб .then у renderForm чекав
                    return this.renderPriceInformation(
                        priceInfo, city, postalcode, street, houseNumStr, consumptionNum
                    );
                }
            })
            .catch(error => {
                console.error('Error:', error);
                $(SELECTORS.PRICE_INFO_CONTAINER).html(
                    '<div class="error-wrapper"><h4 class="error-msg">Wir machen gerade ein Update, bitte versuche es später erneut.</h4></div>'
                );
            });
    }


    renderPriceInformation(data, city, postalcode, street = '', housenumber = '', consumption, secretKey = '', referralContractNumber = '') {
        return new Promise((resolve, reject) => {
            const $this = this;

            const needTabs = Array.isArray(this.allowedTariffs) && this.allowedTariffs.length === 2;
            const tabsData = [];


            if (data && data.priceInformation && data.priceInformation.length > 0) {
                let priceInfoHtmlArray = [];

                const allowedSet = new Set((this.allowedTariffs || []).map(String));
                const items = (allowedSet.size > 0)
                    ? data.priceInformation.filter(t => allowedSet.has(String(t.tariff.id)))
                    : data.priceInformation.slice();

                if (items.length === 0) {
                    $(SELECTORS.PRICE_INFO_CONTAINER).html(
                        `<div class="error-wrapper text-3"><p>Kein Tarif gefunden.</p></div>`
                    );
                    return resolve();                // <— важливо
                }

                // ДАЛІ працюємо з items замість data.priceInformation
                const ajaxPromises = items.map((tariffInfo, idx) => {
                    const {tariff, priceCalculation, additionalCalculationData} = tariffInfo;
                    const {nameExtern, energyPriceGross, energyPriceNet, baseFeeGross, runtimeInMonth} = tariff;
                    const {totalCostPerMonth, totalCostPerYear} = priceCalculation;
                    const {expectedPaymentPlanPerMonth} = additionalCalculationData[0];
                    const totalChargesPerKwH = tariffInfo.charges.totalChargesPerKwH;

                    const totalChargesPerKwHInEuro = totalChargesPerKwH / 100;
                    const totalExpensesCostPerKwH = data.expenses.totalExpensesCostPerKwH || 0;
                    const totalExpensesCostPerKwHInEuro = totalExpensesCostPerKwH / 100;
                    const totalExpensesCostPerYear = data.expenses.totalExpensesCostPerYear || 0;

                    function ajaxRequestAsPromise(requestData) {
                        return new Promise((resolve, reject) => {
                            $.ajax({
                                url: myajax.url,
                                method: 'POST',
                                data: requestData,
                                success(response) {
                                    if(!response.success) {
                                        reject(new Error(response.data));
                                    }
                                    resolve(response);
                                },
                                error(jqXHR, textStatus, errorThrown) {
                                    reject(new Error('AJAX error: ' + textStatus + ' - ' + errorThrown));
                                }
                            });
                        });
                    }

                    return ajaxRequestAsPromise({
                        action: 'get_tariff_info',
                        city,
                        postalCode: postalcode,
                        tariff_id: tariff.id,
                        nonce: myajax.nonces.get_tariff_info
                    }).then(response => {
                        if (response.data && !response.data.error) {
                            const ru = response.data;

                            const bundle = TariffRenderer.buildTariffBundle({
                                idPrefix: '',
                                tariffInfo,
                                responseData: ru,
                                consumption,
                                showChooseButton: true,
                                chooseButtonLabel: 'Tarif buchen',
                                chooseButtonClass: '-new',
                                showDescription: true
                            });

                            tabsData.push({ id: tariff.id, name: nameExtern });

                            $this.tariffUiById[tariff.id] = {
                                ...($this.tariffUiById[tariff.id] || {}),
                                step4TableTotalPrice: bundle.step4TableTotalPrice
                            };

                            let mainTariffHtml = bundle.mainHtml;

                            if (needTabs && idx === 1) {
                                mainTariffHtml = mainTariffHtml.replace('class="tariff-info-box"', 'class="tariff-info-box hidden"');
                            }

                            priceInfoHtmlArray.push(`
                                ${mainTariffHtml}
                                ${bundle.popupsHtml}
                            `);

                            return {
                                idx,
                                id: tariff.id,
                                name: nameExtern,
                                mainHtml: mainTariffHtml,
                                popupsHtml: bundle.popupsHtml
                            };
                        }
                        return null;
                    });
                });

                Promise.all(ajaxPromises)
                    .then(results => {
                        const rows = results.filter(Boolean).sort((a, b) => a.idx - b.idx);

                        if (!rows.length) {
                            $(SELECTORS.PRICE_INFO_CONTAINER).html(
                                `<div class="error-wrapper text-3"><p>Kein Tarif gefunden.</p></div>`
                            );
                            return resolve();
                        }

                        if (needTabs && rows.length === 2) {
                            const tabsHtml = `
                              <div class="tariffs-tabs">
                                <button class="tab-btn active" data-target-tariff="${rows[0].id}">${rows[0].name}</button>
                                <button class="tab-btn" data-target-tariff="${rows[1].id}">${rows[1].name}</button>
                              </div>
                            `;

                            const bodyHtml = rows.map((r, i) =>
                                (i === 1)
                                    ? r.mainHtml.replace('class="tariff-info-box"', 'class="tariff-info-box hidden"')
                                    : r.mainHtml
                            ).join('');

                            $(SELECTORS.PRICE_INFO_CONTAINER).html(tabsHtml + bodyHtml);

                            // попапи — в окремий контейнер
                            $(SELECTORS.POPUP_WRAPPER).html(rows.map(r => r.popupsHtml).join(''));

                            // перемикач табів
                            $(SELECTORS.PRICE_INFO_CONTAINER)
                                .off('click', '.tariffs-tabs .tab-btn')
                                .on('click', '.tariffs-tabs .tab-btn', function (e) {
                                    e.preventDefault();
                                    const $btn = $(this);
                                    const targetId = String($btn.data('target-tariff'));

                                    $btn.addClass('active').siblings().removeClass('active');

                                    const $container = $(SELECTORS.PRICE_INFO_CONTAINER);
                                    $container.find('.tariff-info-box').addClass('hidden');
                                    $container
                                        .find(`.tariff-info[data-tariff="${targetId}"]`)
                                        .closest('.tariff-info-box')
                                        .removeClass('hidden');

                                    setTimeout(function () {
                                        if ($(SWIPER.CONTAINER).length > 0) {
                                            $this.swiper.updateAutoHeight();
                                        }
                                    }, 10);
                                });

                        } else {
                            // 1 тариф (або на всяк випадок !=2)
                            $(SELECTORS.PRICE_INFO_CONTAINER).html(rows.map(r => r.mainHtml).join(''));
                            $(SELECTORS.POPUP_WRAPPER).html(rows.map(r => r.popupsHtml).join(''));
                        }

                        $(SELECTORS.PRICE_INFO_CONTAINER)
                            .off('click', '[id^="choose-tariff-"]')
                            .on('click', '[id^="choose-tariff-"]', (e) => {
                                e.preventDefault();
                                const id = String($(e.currentTarget).attr('id')).replace('choose-tariff-', '');
                                this.chooseTariff(id);

                                this.scrollIntoView($(SELECTORS.FORM_CONTAINER));
                            });

                        resolve();
                    })
                    .catch(err => {
                        this.hideLoader();
                        this.loading = false;
                        console.error(err);
                        $(SELECTORS.PRICE_INFO_CONTAINER).html(
                            `<div class="error-wrapper text-3"><p>Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.</p></div>`
                        );
                        resolve();
                    });

            } else {
                resolve();
            }
        });

    }

    updateStepText(stepIndex = 0) {
        const $slides = $('.multistep-slider .swiper-slide');
        const total = $slides.length || 1;
        const current = Math.min(stepIndex + 1, total);

        // "Schritt X von N"
        $(SELECTORS.STEPS_TEXT).text(`Schritt ${current} von ${total}`);

        // оновити title з атрибуту data-title активного слайда (якщо є)
        const $active = $($slides.get(stepIndex));
        const title = $active.data('title');
        if (title) {
            $(SELECTORS.STEP_TITLE).text(title);
        }
    }

    chooseTariff(tariffId) {
        const id = String(tariffId);
        this.chosenTariff = id;

        const cached = this.tariffUiById[id];
        if (cached && cached.step4TableTotalPrice) {
            $(SELECTORS.STEP4_TABLE_TOTAL).html(cached.step4TableTotalPrice);
        } else {
            $(SELECTORS.STEP4_TABLE_TOTAL).empty();
        }

        console.log(cached);

        this.slideNextSafely();
    }

    initSwiper() {
        if (this.swiper) return;

        const el = document.querySelector(SWIPER.CONTAINER);
        if (!el) {
            document.addEventListener('DOMContentLoaded', () => {
                if (!this.swiper) {
                    const el2 = document.querySelector(SWIPER.CONTAINER);
                    if (el2) {
                        this.swiper = new Swiper(el2, {
                            slidesPerView: 1,
                            loop: false,
                            autoHeight: true,
                            spaceBetween: 20,
                            allowTouchMove: false,
                            allowSlidePrev: false,
                            allowSlideNext: false,
                        });
                        // track current index
                        this._prevIndex = this.swiper.activeIndex || 0;
                        this.updateStepLine(this.swiper.activeIndex);
                        this.updateStepText(this.swiper.activeIndex);

                        this.swiper.on('slideChange', () => {
                            const cur  = this.swiper.activeIndex;
                            const prev = (typeof this._prevIndex === 'number') ? this._prevIndex : cur;

                            // call when moving 1 -> 2 (тобто step2 -> step3, бо індекси 0-базові)
                            if (prev === 1 && cur === 2) {
                                this.syncSecondToThird();
                            }

                            this.updateStepLine(cur);
                            this.updateStepText(cur);
                            this._prevIndex = cur;
                        });
                    }
                }
            }, { once: true });
            return;
        }

        this.swiper = new Swiper(el, {
            slidesPerView: 1,
            loop: false,
            autoHeight: true,
            spaceBetween: 20,
            allowTouchMove: false,
            allowSlidePrev: false,
            allowSlideNext: false,
        });

        // track current index
        this._prevIndex = this.swiper.activeIndex || 0;
        this.updateStepLine(this.swiper.activeIndex);
        this.updateStepText(this.swiper.activeIndex);

        this.swiper.on('slideChange', () => {
            const cur  = this.swiper.activeIndex;
            const prev = (typeof this._prevIndex === 'number') ? this._prevIndex : cur;

            // саме тут робимо синхронізацію при вході на step3
            if (prev === 1 && cur === 2) {
                this.syncSecondToThird();
            }

            this.updateStepLine(cur);
            this.updateStepText(cur);
            this._prevIndex = cur;
        });
    }


    slideToSafely(index) {
        const s = this.swiper;
        if (!s || typeof s.slideTo !== 'function') return Promise.resolve(false);

        // тимчасово дозволяємо перемикання
        s.allowSlideNext = true;
        s.allowSlidePrev = true;

        return new Promise((resolve) => {
            const cleanup = () => {
                s.off('transitionEnd', cleanup);
                // блокуємо назад
                s.allowSlideNext = false;
                s.allowSlidePrev = false;
                resolve(true);
            };

            // якщо Swiper вже на місці або без анімації — підстрахуємося таймером
            s.on('transitionEnd', cleanup);
            s.slideTo(index);

            // fallback, якщо подія не спрацює (на всяк випадок)
            setTimeout(cleanup, 1000);
        });
    }

    slideNextSafely() {
        if (!this.swiper) return Promise.resolve(false);
        return this.slideToSafely(this.swiper.activeIndex + 1);
    }

    slidePrevSafely() {
        if (!this.swiper) return Promise.resolve(false);
        return this.slideToSafely(this.swiper.activeIndex - 1);
    }

    // Initialize form logic
    initializeForm() {
        return new Promise((resolve, reject) => {
            try {
                this.initializeDatePickers();
                resolve();
            } catch (error) {
                reject('Failed to setup uploader.');
            }
        });
    }

    initializeDatePickers() {
        this.setupFlatpickr(SELECTORS.DATE_PICKER_14, {minDate: new Date().fp_incr(14)});
        this.setupFlatpickr(SELECTORS.DATE_PICKER_1, {minDate: new Date().fp_incr(1)});
    }

    setupFlatpickr(selector, additionalOptions = {}) {
        setTimeout(() => {
            $(selector).each(function () {
                const $pickerElement = $(this);

                const flatpickrInstance = $pickerElement.flatpickr({
                    locale: German,
                    altInput: true,
                    altFormat: "d.m.Y",
                    dateFormat: "Y-m-d",
                    allowInput: true,
                    clickOpens: false,
                    disableMobile: true,
                    onValueUpdate(selectedDates, dateStr, instance){ $(instance.input).valid(); },
                    onClose(selectedDates, dateStr, instance){ $(instance.input).valid(); },
                    ...additionalOptions
                });

                $pickerElement.closest(SELECTORS.FIELD_CONTAINER).find(SELECTORS.DATE_ICON).on("click", function () {
                    flatpickrInstance.open();
                });
            });
        }, 10);
    }


    validateForm() {
        this.setupValidationMessages();
        this.setupValidationMethods();
        this.setupFormValidation();
        this.checkFields();
        this.showHiddenFields();
        this.hideTriggeredFields();
    }

    showHiddenFields() {
        $('[data-show-triggers]').each((index, element) => {
            const $container = $(element);
            const triggers = JSON.parse($container.attr('data-show-triggers').replace(/'/g, '"'));
            this.checkTriggers($container, triggers);
        });
    }

    // --- NEW: hide by triggers (inverse of show) ---
    hideTriggeredFields() {
        $('[data-hide-triggers]').each((index, element) => {
            const $container = $(element);
            // Support single quotes inside attribute JSON
            const triggers = JSON.parse($container.attr('data-hide-triggers').replace(/'/g, '"'));
            this.checkHideTriggers($container, triggers);
        });
    }

    /**
     * Inverse of checkTriggers:
     * - if all conditions match -> hide container
     * - else -> show container back
     */
    checkHideTriggers($container, triggers) {
        let shouldHide = true;

        // Evaluate all trigger conditions
        for (let trigger in triggers) {
            const expectedValue = String(triggers[trigger]);
            const $inputsByName = $(`input[name="${trigger}"], select[name="${trigger}"]`);
            let inputValue = '';

            if ($inputsByName.length) {
                const $first = $inputsByName.eq(0);

                if ($first.is('[type="checkbox"]')) {
                    // If there are multiple checkboxes with same name, treat as OR: any checked equals expected
                    const anyChecked = $inputsByName.is(':checked');
                    inputValue = anyChecked ? 'true' : 'false';
                } else if ($first.is('[type="radio"]')) {
                    inputValue = $(`input[name="${trigger}"]:checked`).val() || '';
                } else if ($first.is('select')) {
                    // Support multi-select too
                    const val = $first.val();
                    inputValue = Array.isArray(val) ? val.join(',') : (val || '');
                } else {
                    inputValue = $first.val() || '';
                }
            }

            if (String(inputValue) !== expectedValue) {
                shouldHide = false;
                break;
            }
        }

        if (shouldHide) {
            // Hide container and relax 'required' flags
            $container.removeClass('-show');

            if (!$container.hasClass('show-trigger-container')) {
                const $triggeredInputs = $container.find('input, select, textarea');
                const hadRequired = $triggeredInputs.is('[required]');
                if (hadRequired) {
                    // Remember that it was required only when shown
                    $container.addClass('required-if-showed');
                    $triggeredInputs.attr('required', false);
                }
            }

            // Clear values + validation states to avoid accidental submission
            // this.clearContainerTextInputs($container);

        } else {
            // Show container back and restore 'required' if it was marked earlier
            $container.addClass('-show');

            if (!$container.hasClass('show-trigger-container')) {
                const $triggeredInputs = $container.find('input, select, textarea');
                const restoreRequired = $container.hasClass('required-if-showed');
                if (restoreRequired) {
                    $container.removeClass('required-if-showed');
                    $triggeredInputs.attr('required', true);
                }
            }
        }
    }

    initializeEventListeners() {
        // Global event listeners here

        $(document).on('click', SELECTORS.DATE_LABEL, (e) => this.handleDateLabelClick(e));

        $(document).on('keyup blur change', SELECTORS.ALL_INPUTS, (e) => this.handleInputValidation(e));

        // Handle input events
        $(document).on('input', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleInputEvent(e));

        // Handle focus events
        $(document).on('focus', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleFocusEvent(e));

        // Handle blur events
        $(document).on('blur', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleBlurEvent(e));

        // Handle date input events
        $(document).on('focus', SELECTORS.DATE_INPUT, (e) => this.handleDateInputFocus(e));
        $(document).on('blur', SELECTORS.DATE_INPUT, (e) => this.handleDateInputBlur(e));

        $(document).on('focus', SELECTORS.BANK_ACCOUNT_IBAN_INPUT, function () {
            const $el = $(this);
            if ($el.data('iban-masked')) return;

            $el.inputmask("DE99 9999 9999 9999 9999 99", {
                mask: "DE99 9999 9999 9999 9999 99",
                placeholder: "",
                clearIncomplete: false,
                rightAlign: false,
                definitions: {
                    '9': {
                        validator: "[0-9]",
                        cardinality: 1
                    }
                }
            });

            $el.data('iban-masked', true);
        });

        // $(SELECTORS.FORM).on('invalid-form.validate', (e, validator) => {
        //     console.warn('[invalid]', validator.errorList.map(x => ({
        //         name: x.element.name,
        //         msg: x.message,
        //         hidden: $(x.element).is(':hidden')
        //     })));
        // });

        this.onLoadingChange = (isLoading) => {
            if (isLoading) {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', true).addClass('-loading');
            } else {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', false).removeClass('-loading');
            }
        };

        // NEXT
        $(document).on('click', SELECTORS.NEXT_BUTTONS, async (e) => {
            e.preventDefault();
            if (!this.swiper) return;

            const currentIndex = this.swiper.activeIndex;
            const $currentSlide = $(this.swiper.slides[currentIndex]);

            if (!this.validateInputsOnSlide(currentIndex)) {
                const $errWrap = $currentSlide.find('.field-wrap.nf-error').first();
                if ($errWrap.length) {
                    this.scrollIntoView($errWrap);
                    const $errInput = $errWrap.find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]').first();
                    if ($errInput.length) $errInput.focus();
                }
                return;
            }

            await this.slideNextSafely();

            // якщо щойно потрапили на step3 (index 2) — синхронізуємо
            if (this.swiper.activeIndex === 2) {
                this.syncSecondToThird();
            }

            this.checkFieldsOnStep(this.swiper.activeIndex);
            this.scrollIntoView($(SELECTORS.FORM_CONTAINER));
        });

        // PREV
        $(document).on('click', SELECTORS.PREV_LINKS, async (e) => {
            e.preventDefault();
            if (!this.swiper) return;

            const currentIndex = this.swiper.activeIndex;
            const href = $(e.currentTarget).attr('href');

            if (currentIndex > 0) {
                await this.slidePrevSafely();
                this.checkFieldsOnStep(this.swiper.activeIndex);
                this.scrollIntoView($(SELECTORS.FORM_CONTAINER));
            } else {
                if (href && href !== '' && href !== '#') {
                    window.location.href = href;
                } else {
                    history.back();
                }
            }
        });

        // Toggle collapsed editors (open/close) on Step 3
        $(document).on('click', '.collapsed-data .open-fields-link a, .collapsed-data .close-fields-link a', (e) => {
            e.preventDefault();

            const $link = $(e.currentTarget);
            const $item = $link.closest('.item');
            const $collectedInfoBox = $item.find('.collected-info');
            const $formFieldsBox = $item.find('.form-fields');

            // lightweight validation inside a specific box
            const validateInputsInBox = ($box) => {
                let ok = true;
                const $form = $(SELECTORS.FORM);
                const v = $form.data('validator');

                // All inputs except hidden/select2 shadow
                $box.find(':input').not('.select2-hidden-accessible, [type="hidden"]').each(function () {
                    const $el = $(this);
                    // run jQuery Validate if present
                    if (v) v.element(this);
                    // also check DOM validity + NF error class
                    const $wrap = $el.closest('.field-wrap');
                    if (!this.checkValidity || !this.checkValidity() || $wrap.hasClass('nf-error')) {
                        ok = false;
                    }
                });

                return ok;
            };

            if ($link.parent().hasClass('open-fields-link')) {
                // Open editor
                $collectedInfoBox.hide();
                $formFieldsBox.show();
            } else {
                // Close editor -> validate first
                if (!validateInputsInBox($formFieldsBox)) return;
                $collectedInfoBox.show();
                $formFieldsBox.hide();
            }

            // Smooth scroll to the edited item
            this.scrollIntoView($item);

            // Update swiper height safely
            setTimeout(() => {
                const el = document.querySelector(SWIPER.CONTAINER);
                if (el && this.swiper) {
                    this.swiper.updateAutoHeight();
                }
            }, 10);
        });

        // When user decides to keep payment method from contract
        $(document).on('change', 'input[name="keepPaymentMethod"]', (e) => {
            const checked = $(e.currentTarget).is(':checked');
            const $ibanChecker = $('#iban-checker');

            // Take bank data from contract (same logic as in seedDefaultFormDataFromContract)
            const b = this.contractData?.business || {};

            const list = Array.isArray(b.bankAccounts) ? b.bankAccounts : [];
            const primary =
                list.find(x => x && (x.iban || x.bankName || x.bic || x.ownerName)) ||
                list[0] ||
                {};

            const cOwner = primary.ownerName ? primary.ownerName.trim() : '';
            const rawIban = (primary.iban || b.bankAccountIban || b.bankData?.iban || '')
                .replace(/\s+/g, '')
                .toUpperCase();
            const cBank = primary.bankName || b.bankData?.bankName || '';
            const cBic  = primary.bic || b.bankData?.bic || '';

            if (checked) {
                if (!rawIban && !cBank && !cBic) {
                    this.updateRadioButtons('paymentType', 'rechnung');
                    // text in #iban-checker will be set by paymentType change handler
                } else {
                    // We have bank data -> use SEPA and show contract bank info in ibanChecker
                    this.updateRadioButtons('paymentType', 'sepaLastschrift');
                }

                // Prefill bank inputs from contract snapshot (your existing method)
                if (typeof this.prefillBankFieldsFromContract === 'function') {
                    this.prefillBankFieldsFromContract();
                }

            } else {
                this.updateRadioButtons('paymentType', 'sepaLastschrift');
            }

            this.syncSecondToThird();

            this.safeUpdateAutoHeight();
        });


    }

    handleDateLabelClick(event) {
        event.preventDefault();

        const $label = $(event.currentTarget);
        const fieldId = $label.attr('for');
        let $currentField = $(`#${fieldId}`);

        if ($currentField.length > 0 && $currentField.attr('type') === 'hidden') {
            $currentField = $currentField.next();
        }

        $currentField.focus();
    }

    showLoader() {
        $(SELECTORS.LOADER).show();
    }

    hideLoader() {
        $(SELECTORS.LOADER).hide();
        $(SELECTORS.FORM_CONTAINER).removeClass('-hidden');
    }

    setupValidationMessages() {
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein.")
        });
    }

    setupValidationMethods() {

        $.validator.addMethod("lettersDigitsHyphen", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9-]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Zahlen und Bindestriche ein.");

        $.validator.addMethod("dateFuture", function(value, element) {
            const selectedDate = new Date(value);

            const currentDate = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);

            return this.optional(element) || selectedDate > currentDate;
        }, "Datum muss in der Zukunft liegen");

        // Validation method: checks that IBAN contains exactly 22 characters (excluding spaces)
        $.validator.addMethod("ibanLength", function(value, element) {
            // Remove all spaces
            var valueWithoutSpaces = value.replace(/\s+/g, '');
            var valueWithoutLines = valueWithoutSpaces.replace('_', '');
            // Check that the length is exactly 22 characters
            return valueWithoutLines.length === 22;
        }, "IBAN muss 22 Zeichen lang sein");

        // Validation method: checks that the first two letters are 'DE'
        $.validator.addMethod("germanIbanPrefix", function(value, element) {
            // Remove all spaces to ensure correct checking regardless of formatting
            var valueWithoutSpaces = value.replace(/\s+/g, '');
            // Check that the first two letters are 'DE'
            return /^DE/.test(valueWithoutSpaces);
        }, "Bitte gib eine deutsche IBAN an");

        // Date must be >= today + 14 days
        $.validator.addMethod("notSoonerThan14Days", function (value, element) {
            if (this.optional(element)) return true;

            // Parse selected date; reject if invalid
            const selectedDate = new Date(value);
            if (isNaN(selectedDate)) return false;

            // Normalize to midnight to avoid time drift
            selectedDate.setHours(0, 0, 0, 0);

            // Today at midnight
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Minimum allowed date: today + 14 days
            const minAllowed = new Date(today);
            minAllowed.setDate(minAllowed.getDate() + 14);

            return selectedDate >= minAllowed;
        }, "Dein frühstmögliches Kündigungsdatum muss mindestens 14 Tage in der Zukunft liegen.");


        $.validator.addMethod("germanIbanValidation", function(value, element) {
            // Remove all spaces and convert to uppercase
            var iban = value.replace(/\s+/g, '').toUpperCase();

            // Check that IBAN matches German format (DE + 20 цифр)
            if (!/^DE\d{20}$/.test(iban)) {
                return false;
            }

            // Rearrangement: move the first 4 characters (country code and check digits) to the end
            var rearranged = iban.slice(4) + iban.slice(0, 4);

            // Convert letters to numbers (A=10, B=11, ..., Z=35)
            var numericIban = "";
            for (var i = 0; i < rearranged.length; i++) {
                var ch = rearranged.charAt(i);
                if (ch >= 'A' && ch <= 'Z') {
                    numericIban += (ch.charCodeAt(0) - 55);
                } else {
                    numericIban += ch;
                }
            }

            // Perform mod-97 validation in chunks to avoid precision issues for very long numbers
            var remainder = numericIban;
            while (remainder.length > 2) {
                var block = remainder.substring(0, 9);
                remainder = (parseInt(block, 10) % 97).toString() + remainder.substring(block.length);
            }

            return parseInt(remainder, 10) % 97 === 1;
        }, "Die eingegebene IBAN ist ungültig, bitte überprüfe Deine Eingabe");

    }

    setupFormValidation(form) {
        let $this = this;

        $(SELECTORS.FORM).validate({
            ignore: ".datepicker.input",
            rules: {
                supplyEndDate: {
                    notSoonerThan14Days: true,
                },
                supplyBeginDate: {
                    dateFuture: true,
                },
                deliveryPointMeteringDeviceNumber: {
                    lettersDigitsHyphen: true
                },
                marketLocation: {
                    rangelength: {
                        param: [11, 11],
                        depends: () => $('input[name="meterNumberCheckbox"]').prop('checked')
                    },
                    digits: {
                        param: true,
                        depends: () => $('input[name="meterNumberCheckbox"]').prop('checked')
                    }
                },
                bankAccountIban: {
                    ibanLength: {
                        param: true,
                        depends: () => ($('input[name="paymentType"]:checked').val() === 'sepaLastschrift' && !$('input[name="keepPaymentMethod"]').is(':checked'))
                    },
                    germanIbanPrefix: {
                        param: true,
                        depends: () => ($('input[name="paymentType"]:checked').val() === 'sepaLastschrift' && !$('input[name="keepPaymentMethod"]').is(':checked'))
                    },
                    germanIbanValidation: {
                        param: true,
                        depends: () => ($('input[name="paymentType"]:checked').val() === 'sepaLastschrift' && !$('input[name="keepPaymentMethod"]').is(':checked'))
                    }
                },

            },
            messages: {
                supplyEndDate: {
                    required: "Datum muss mindestens 14 Tage in der Zukunft liegen.",
                    notSoonerThan14Days: "Datum muss mindestens 14 Tage in der Zukunft liegen."
                },
                supplyBeginDate: {
                    required: "Datum muss in der Zukunft sein.",
                    dateFuture: "Datum muss in der Zukunft sein."
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
                if ($this.swiper) {
                    $this.swiper.updateAutoHeight();
                } // Update Swiper height when error message is shown
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
                if ($this.swiper) {
                    $this.swiper.updateAutoHeight();
                } // Update Swiper height when field is highlighted
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
                if ($this.swiper) {
                    $this.swiper.updateAutoHeight();
                } // Update Swiper height when field is unhighlighted
            },
            success: function (label, element) {
                $(element).closest('.field-wrap').addClass('nf-pass');
                if ($this.swiper) {
                    $this.swiper.updateAutoHeight()
                } // Update Swiper height when field is valid
            },
            submitHandler: (form, event) => {
                event.preventDefault();
                console.log('trying submit');
                $this.handleFormSubmit(event);
            }
        });
    }

    handleInputValidation(event) {
        let $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        const $wrap = $input.closest('.field-wrap');

        if ($input.length > 0) {
            if ($input.attr('type') === 'hidden') {
                $input = $input.next();
            }
        }

        // Validate the input
        const v = $(SELECTORS.FORM).data('validator');
        if (v) v.element($input[0]);

        // Add or remove "fake-nf-pass" based on the input value
        if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr) {
            if ($input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            } else {
                $container.removeClass('fake-nf-pass');
                $wrap.removeClass('nf-pass');
            }
        }
    }

    handleInputEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        let value = $input.val();

        if ($input.is('select[multiple]')) {
            value = Array.isArray(value) && value.length > 0 ? value.join('').trim() : '';
        } else if ($input.is('select')) {
            value = value ? value.trim() : '';
        } else if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }

        const name = $input.attr('name');
        if (name) this.updateSummaryForName(name);
    }

    handleFocusEvent(event) {
        const $input = $(event.currentTarget);
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    }

    handleBlurEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');
        if ($input.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        }
    }

    // Check Ninja Forms fields
    checkFields() {
        $(SELECTORS.ALL_INPUTS).each(function () {
            let $input = $(this);
            let $attr = $input.attr('required');
            let $container = $input.closest(SELECTORS.FIELD_CONTAINER);
            const v = $(SELECTORS.FORM).data('validator');

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
            if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                $container.addClass('potentially-required-label');
            }

            if (($input.is('[type="text"]') || $input.is('[type="email"]') || $input.is('[type="tel"]') || $input.is('[type="number"]') || $input.is('[type="date"]')) && $input.val().trim() !== '') {
                if (v) v.element($input[0]);
            }

            if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr && $input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            }
        });
    }

    handleDateInputFocus(event) {
        const $input = $(event.currentTarget);
        $input.inputmask({
            mask: "99.99.9999",
            placeholder: "tt.mm.jjjj",
            clearIncomplete: true,
        });
    }

    handleDateInputBlur(event) {
        const $input = $(event.currentTarget);
        $input.inputmask('remove');
        $input.attr('placeholder', '');
    }

    getContractInfo() {
        if (this.loading) return;

        this.loading = true;
        this.showLoader();

        if (!this.contractNumberValue) {
            return Promise.reject('ContractNumber is missing in URL parameters');
        }

        const sendData = {
            action: 'get_umzug_contract_info',
            nonce:  myajax.nonces.get_umzug_contract_info,
            contractNumber: this.contractNumberValue
        };

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: sendData,
                dataType: 'json',
                success: (response) => {
                    if (response && response.success && response.data) {
                        this.contractData = response.data
                        console.log(this.contractData);

                        this.businessPartnerNumberValue = this.contractData?.business?.businessPartnerNumber || '';
                        resolve(this.contractData);
                    } else {
                        reject(response?.data || 'Empty response or form data is missing.');
                    }
                },
                error: (xhr, status, error) => {
                    reject(error || status);
                }
            });
        });
    }

    getContractState() {
        if (!this.contractNumberValue) {
            return Promise.reject('ContractNumber is missing in URL parameters');
        }

        const sendData = {
            action: 'get_umzug_contract_state',
            nonce:  myajax.nonces.get_umzug_contract_state,
            contractNumber: this.contractNumberValue
        };

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: sendData,
                dataType: 'json',
                success: (response) => {
                    if (response && response.success && response.data) {
                        resolve(response.data);
                    } else {
                        reject(response?.data || 'Empty state.');
                    }
                },
                error: (xhr, status, error) => {
                    reject(error || status);
                }
            });
        });
    }

    getContractAdditionalInfo() {
        console.log(this.businessPartnerNumberValue);
        // Always resolve; never reject
        if (!this.businessPartnerNumberValue) {
            return Promise.resolve(null);
        }

        const sendData = {
            action: 'get_umzug_contract_info_additional',
            nonce:  myajax.nonces.get_umzug_contract_info_additional,
            businessNumber: this.businessPartnerNumberValue
        };

        return new Promise((resolve) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: sendData,
                dataType: 'json',
            })
                .done((response) => {
                    console.log(response);
                    if (response && response.success && response.data) {
                        resolve(response.data);
                    } else {
                        // Empty or unexpected response -> continue silently
                        resolve(null);
                    }
                })
                .fail(() => {
                    // Network/backend error -> continue silently
                    resolve(null);
                });
        });
    }

    applyContractAdditionalEffects(additional) {
        console.log(additional);
        // We only care if booleanAdditional2 === true; otherwise do nothing
        if (!additional || additional.agreement !== true) return;

        // Remember for payload enrichment
        this.forceAdvertisingConsentTrue = true;

        // Remove consent UI before validation is initialized
        const $blocks = $('.advertising-consent-block');

        if ($blocks.length) {
            // Drop required from any inputs inside to avoid validation leftovers
            $blocks.find('input, select, textarea').each(function () {
                const $el = $(this);
                $el.removeAttr('required');
                const $wrap = $el.closest('.field-wrap');
                $wrap.removeClass('nf-error nf-pass');
                $wrap.find('.nf-error-msg').empty();
            });

            // Remove the blocks from DOM
            $blocks.remove();

            // If swiper exists later, we'll update height; for now try safe update
            this.safeUpdateAutoHeight?.();
        }
    }

    // ---- [A] УТИЛІТИ ----
    formatDateISOToDE(iso) {
        if (!iso) return '';
        // приймає '1955-05-11' або '2025-02-05T23:00:00.000Z'
        const d = new Date(iso);
        if (isNaN(d)) return '';
        const dd = String(d.getDate()).padStart(2,'0');
        const mm = String(d.getMonth()+1).padStart(2,'0');
        const yyyy = d.getFullYear();
        return `${dd}.${mm}.${yyyy}`;
    }

    formatEpochMsToDE(ms) {
        if (!ms && ms !== 0) return '';
        const d = new Date(Number(ms));
        if (isNaN(d)) return '';
        const dd = String(d.getDate()).padStart(2,'0');
        const mm = String(d.getMonth()+1).padStart(2,'0');
        const yyyy = d.getFullYear();
        return `${dd}.${mm}.${yyyy}`;
    }

    _setDataName(name, value) {
        const $nodes = $(`[data-name="${name}"]`);
        if (!$nodes.length) return;
        const safe = this._sanitizeForDisplay(value);
        $nodes.each(function () { $(this).text(safe); });
    }

    getAddressFieldMap() {
        const p = this.urlParams || {};
        return {
            'address.street'             : p.street,
            'address.housenumber'        : p.housenumber,
            'address.housenumberAdditional': p.housenumberAdditional, // якщо не передають — буде ''
            'address.postalCode'         : p.postalcode,
            'address.city'               : p.city,
        };
    }

    fillAddressSummary() {
        const map = this.getAddressFieldMap();
        Object.keys(map).forEach(key => this._setDataName(key, map[key]));
    }

    getCustomerFieldMap() {
        const salMap = { '2': 'Herr', '1': 'Frau', '3': 'Familie', '5': 'Divers' };
        const d = this.contractData || {};
        const b = (d.business || {});

        // dateOfBirth
        const dob =
            this.formatDateISOToDE(b.dateOfBirth) ||
            this.formatEpochMsToDE(b.originalDateOfBirth);

        // phone
        const phone =
            (b.phoneNumber || '') ||
            ((Array.isArray(b.phoneNumbers) && b.phoneNumbers[0]?.number) || '');

        // email
        const email = (b.newEmail && b.newEmail.trim()) ? b.newEmail : (b.email || '');

        return {
            'customer.salutation'  : salMap[String(b.salutation || '')] || '',
            'customer.title'       : b.title || '',
            'customer.firstname'   : b.firstName || '',
            'customer.lastname'    : b.name || '',
            'customer.email'       : email,
            'customer.phoneNumber' : phone,
            'customer.dateOfBirth' : dob,
        };
    }

    fillCustomerSummary() {
        if (!this.contractData || !this.contractData.business) return;

        const map = this.getCustomerFieldMap();
        Object.keys(map).forEach(key => this._setDataName(key, map[key]));
    }

    checkTriggers($container, triggers) {
        let shouldShow = true;

        for (let trigger in triggers) {
            const expectedValue = triggers[trigger];
            const inputTrigger = $('input[name=' + trigger + ']');
            let inputValue = '';

            if (inputTrigger.attr('type') === 'checkbox') {
                inputValue = inputTrigger.is(':checked') ? 'true' : 'false';
            } else if (inputTrigger.attr('type') === 'radio') {
                inputValue = $('input[name=' + trigger + ']:checked').val();
            }

            if (inputValue !== expectedValue) {
                shouldShow = false;
                break;
            }
        }

        if (shouldShow) {
            $container.addClass('-show');

            if(!$container.hasClass('show-trigger-container')) {
                let checkRequired = $container.hasClass('required-if-showed');
                let triggeredInput = $container.find('input, select');

                if (checkRequired) {
                    $container.removeClass('required-if-showed');
                    triggeredInput.attr('required', true);
                }
            }
        } else {
            $container.removeClass('-show');

            if(!$container.hasClass('show-trigger-container')) {
                let triggeredInput = $container.find('input, select');
                let checkRequired = typeof triggeredInput.attr('required') !== 'undefined' && triggeredInput.attr('required') !== false;

                if (checkRequired) {
                    $container.addClass('required-if-showed');
                    $container.find('input, select').attr('required', false);
                }
            }

            // this.clearContainerTextInputs($container);
        }
    }

    clearContainerTextInputs($container) {
        const $inputs = $container.find('input')
            .not('[type="radio"], [type="checkbox"], [type="button"], [type="submit"]');

        $inputs.each(function () {
            const $f = $(this);

            $f.val('');

            $f.trigger('input').trigger('change');

            const $wrap = $f.closest('.field-wrap');
            $wrap.removeClass('nf-pass nf-error');
            $wrap.find('.nf-error-msg').empty();
        });
    }

    // Attach handlers for IBAN / Owner Name / payment type
    initBankFieldHandlers() {
        const $iban = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT);
        const $owner = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME);

        // When IBAN field loses focus and field is valid -> validate via API
        $(document).on('blur', SELECTORS.BANK_ACCOUNT_IBAN_INPUT, (e) => {
            const $wrap = $(e.currentTarget).closest('.field-wrap');
            // If you use NF classes: validate only when field already "passed"
            if (!$wrap.hasClass('nf-error')) {
                this.validateIBAN();
            }
        });

        const paymentTypeValues = {
            sepaLastschrift: 'SEPA-Lastschrift',
            rechnung: 'auf Rechnung',
        };

        const $checked = $(SELECTORS.PAYMENT_TYPE_RADIO_CHECKED).first();
        if ($checked.length) {
            const thisValue = $checked.val();
            $('#iban-checker').html(paymentTypeValues[thisValue] || '');
        }

        // If payment type changes, reset bank fields (mimic original behavior)
        $(document).on('change', SELECTORS.PAYMENT_TYPE_RADIO_CHECKED, (event) => {
            const $target = $(event.target);
            const thisValue = $target.val();
            const $ibanChecker = $('#iban-checker');

            const paymentTypeValues = {
                'sepaLastschrift': 'SEPA-Lastschrift',
                'rechnung': 'auf Rechnung',
            };

            $ibanChecker.html(`${paymentTypeValues[thisValue]}`);

            // Optional: scroll to bank owner block on mobile (remove if not needed)
            const isMobile = $(window).width() <= 1024;
            if (isMobile && thisValue === 'sepaLastschrift') {
                // Find owner field only inside active slide
                const $activeSlide = $('.swiper-slide-active');
                const $ownerBox = $activeSlide
                    .find(SELECTORS.BANK_ACCOUNT_OWNER_NAME)
                    .closest('.nf-field-container');

                if ($ownerBox.length) {
                    this.scrollIntoView($ownerBox);
                }
            }
        });

        $(document).on('change', SELECTORS.PAYMENT_TYPE_RADIO_CHECKED, (event) => {
            const $target = $(event.target);
            const thisValue = $target.val();
            const $ibanChecker = $('#iban-checker');

            const paymentTypeValues = {
                'sepaLastschrift': 'SEPA-Lastschrift',
                'rechnung': 'auf Rechnung',
            };

            $ibanChecker.html(`${paymentTypeValues[thisValue]}`);

            // Optional: scroll to bank owner block on mobile (remove if not needed)
            const isMobile = $(window).width() <= 1024;
            if (isMobile && thisValue === 'sepaLastschrift') {
                // Find owner field only inside active slide
                const $activeSlide = $('.swiper-slide-active');
                const $ownerBox = $activeSlide
                    .find(SELECTORS.BANK_ACCOUNT_OWNER_NAME)
                    .closest('.nf-field-container');

                if ($ownerBox.length) {
                    this.scrollIntoView($ownerBox);
                }
            }
        });
    }

    // No-op safe autoHeight updater (in case Swiper instance is not available here)
    safeUpdateAutoHeight() {
        try {
            const swiperEl = document.querySelector(SWIPER.CONTAINER);
            if (swiperEl && swiperEl.swiper) {
                setTimeout(() => swiperEl.swiper.updateAutoHeight(), 10);
            }
        } catch (e) { /* ignore */ }
    }

    /** Set value for all inputs by name and trigger appropriate events */
    updateFieldValues(name, newValue, excludeEl) {
        // оновлюємо ВСІ елементи з таким name, крім джерела
        $(`[name="${name}"]`).not(excludeEl).each(function () {
            const $el = $(this);

            if ($el.is(':radio') || $el.is(':checkbox')) return;

            // flatpickr – без зайвих тригерів: setDate(value, true) сам кине change одноразово
            if ($el.hasClass('flatpickr-input') && this._flatpickr) {
                this._flatpickr.setDate(newValue, true);
                return;
            }

            $el.val(newValue).trigger('change');
        });
    }

    /** Mirror radio group checked state to another radio group (name) */
    updateRadioButtons(targetName, value, excludeEl) {
        const $group = $(`input[type="radio"][name="${targetName}"]`).not(excludeEl);
        if (!$group.length) return;
        // змінюємо стан лише якщо реально інший
        const $target = $group.filter(`[value="${value}"]`);
        if (!$target.prop('checked')) {
            $group.prop('checked', false);
            $target.prop('checked', true).trigger('change');
        }
    }

    /** Mirror checkbox state to another checkbox name */
    updateCheckboxes(targetName, isChecked, excludeEl) {
        const checked = (isChecked === true || isChecked === 'true');
        const $cb = $(`input[type="checkbox"][name="${targetName}"]`).not(excludeEl);
        if (!$cb.length) return;
        if ($cb.prop('checked') !== checked) {
            $cb.prop('checked', checked).trigger('change');
        }
    }

    /** Core: copy values from Step 2 -> Step 3 (called on entering Step 3) */
    syncSecondToThird() {
        const $step2 = $(SELECTORS.STEP2_SLIDE);
        const $step3 = $(SELECTORS.STEP3_SLIDE);
        if (!$step2.length || !$step3.length) return;

        // 1) Text/number/date/etc.: same name on both steps
        $step2.find(':input')
            .not('.select2-hidden-accessible')
            .each((_, el) => {
                const $el = $(el);
                const name = $el.attr('name');
                if (!name) return;

                // radios/checkboxes handled in (2)
                if ($el.is(':radio') || $el.is(':checkbox')) return;

                const val = $el.val();
                if (val != null && val !== '') {
                    this.updateFieldValues(name, val);
                }
            });

        // 2) Radios/Checboxes: on Step 3 they have "-copy" suffix
        // radios
        $step2.find('input[type="radio"]').each((_, el) => {
            const $el = $(el);
            const name = $el.attr('name');
            if (!name) return;

            const isChecked = $el.is(':checked');
            const copyName  = `${name}-copy`;
            if (isChecked) {
                this.updateRadioButtons(copyName, $el.val());
            }
        });

        // checkboxes
        $step2.find('input[type="checkbox"]').each((_, el) => {
            const $el = $(el);
            const name = $el.attr('name');
            if (!name) return;

            const isChecked = $el.is(':checked') ? 'true' : 'false';
            const copyName  = `${name}-copy`;
            this.updateCheckboxes(copyName, isChecked);
        });

        // Select2 mirrors (by name, same on both steps)
        $step2.find('select').each((_, el) => {
            const $el = $(el);
            const name = $el.attr('name');
            if (!name) return;

            let value = $el.val();
            if ($.isArray(value)) value = value[0];

            const $targets = $(`select[name="${name}"]`);
            if ($targets.length) {
                $targets.val(value).trigger('change.select2');
            }
        });

        this.safeUpdateAutoHeight();
        this.updateSummaryAll();
    }

    /** Bind live mirroring from Step 3 -> Step 2 inside collapsed editors */
    bindThirdStepMirroring() {
        // 1) text/textarea/select
        $(document).on(
            'blur change',
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} input:not([type="checkbox"]):not([type="radio"]), ` +
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} textarea, ` +
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} select`,
            (e) => {
                if (this._isMirroring()) return;
                const $t = $(e.target);
                const name = $t.attr('name');
                if (!name) return;

                this._enterMirror();
                this.updateFieldValues(name, $t.val(), $t); // не чіпаємо джерело
                this._exitMirror();

                this.updateSummaryForName(name);
            }
        );

// 2) flatpickr (якщо лишаєш окремий)
        $(document).on(
            'change',
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} .flatpickr-input`,
            (e) => {
                if (this._isMirroring()) return;
                const $t = $(e.target);
                const name = $t.attr('name');
                if (!name) return;

                this._enterMirror();
                document.querySelectorAll(`[name="${name}"]`).forEach((el) => {
                    if (el === $t[0]) return; // не чіпаємо джерело
                    const fp = el._flatpickr;
                    if (fp) fp.setDate($t.val(), true);
                    else $(el).val($t.val()).trigger('change');
                });
                this._exitMirror();

                this.updateSummaryForName(name);
            }
        );

// 3) radios
        $(document).on(
            'change',
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} input[type="radio"]`,
            (e) => {
                if (this._isMirroring()) return;
                const $t = $(e.target);
                const name = $t.attr('name');
                const value = $t.val();
                if (!name) return;

                this._enterMirror();
                if (name.endsWith('-copy')) {
                    const original = name.replace(/-copy$/, '');
                    this.updateRadioButtons(original, value, $t);
                } else {
                    const copy = `${name}-copy`;
                    this.updateRadioButtons(copy, value, $t);
                }
                this._exitMirror();

                this.updateSummaryForName(name);
            }
        );

// 4) checkboxes
        $(document).on(
            'change',
            `${SELECTORS.STEP3_SLIDE} ${SELECTORS.STEP3_COLLAPSED_FORM} input[type="checkbox"]`,
            (e) => {
                if (this._isMirroring()) return;
                const $t = $(e.target);
                const name = $t.attr('name');
                const isChecked = $t.is(':checked') ? 'true' : 'false';
                if (!name) return;

                this._enterMirror();
                if (name.endsWith('-copy')) {
                    const original = name.replace(/-copy$/, '');
                    this.updateCheckboxes(original, isChecked, $t);
                } else {
                    const copy = `${name}-copy`;
                    this.updateCheckboxes(copy, isChecked, $t);
                }
                this._exitMirror();

                this.updateSummaryForName(name);
            }
        );
    }

    // Smooth scroll to element
    scrollIntoView($el) {
        const $customerSwitcher = $('.customer-switcher');
        const headerH = ($('header').outerHeight() || 0) + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);
        $('html, body').animate({ scrollTop: $el.offset().top - headerH }, 300);
    }

    // Clear only bank-related inputs + errors
    clearBankInputs() {
        const $owner = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME);
        const $iban  = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT);
        const $bank  = $(SELECTORS.BANK_NAME_INPUT);

        this.bankName = '';
        this.bankAccountBic = '';
        this.bankAccountIban = '';

        const clearOne = ($el) => {
            const $wrap = $el.closest('.field-wrap');
            $wrap.removeClass('nf-error nf-pass iban-api-error');
            $wrap.find('.nf-error-msg, .iban-error-msg').html('');
            $el.val('').trigger('change');
        };

        clearOne($owner);
        clearOne($iban);
        clearOne($bank);

        $(SELECTORS.ERROR_NAME_BANK).removeClass('-show');
        $(SELECTORS.BANK_NAME_INPUT).prop('disabled', true);
        this.safeUpdateAutoHeight();
    }

    // Comments: English (as you prefer)
// Fetch bank meta by IBAN (uses same backend as validateIBAN)
    _fetchBankMetaByIban(ibanRaw) {
        const iban = String(ibanRaw || '').replace(/\s+/g, '').toUpperCase();
        if (!iban || !/^DE\d{20}$/.test(iban)) return Promise.resolve(null);

        // In German IBAN, bank identifier is chars 5..12
        const bankIdentifier = iban.slice(4, 12);

        return new Promise((resolve) => {
            $.ajax({
                url:  myajax.url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'check_bank_name',
                    nonce:  myajax.nonces.check_bank_name,
                    bankIdentifier
                }
            })
                .done((res) => {
                    const d = res && res.data;
                    if (d && d.bank && d.bic) {
                        resolve({ bank: d.bank, bic: d.bic });
                    } else {
                        resolve(null);
                    }
                })
                .fail(() => resolve(null));
        });
    }

    // Validate IBAN and fetch bank name/BIC via backend action `check_bank_name`
    validateIBAN() {
        const $ibanInput = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT);
        const $bankName  = $(SELECTORS.BANK_NAME_INPUT);
        const $errBox    = $(SELECTORS.ERROR_NAME_BANK);
        const $box       = $(SELECTORS.CONTAINER_BANK_NAME);

        const raw = ($ibanInput.val() || '').trim();
        const ibanNoSpaces = raw.replace(/\s+/g, '');

        // Start loading
        $box.addClass('loading');

        // Helper to clear state and fields
        const clearFields = () => {
            if ($bankName.val()) {
                // Drop any prefilled value
                const $wrap = $bankName.closest('.field-wrap');
                $wrap.removeClass('nf-error nf-pass iban-api-error');
                $wrap.find('.nf-error-msg, .iban-error-msg').html('');
                $bankName.val('').trigger('change');
            }
            $bankName.prop('disabled', true);
            $errBox.removeClass('-show');
            this.safeUpdateAutoHeight();
        };

        // If IBAN is empty -> clear & exit
        if (!ibanNoSpaces) {
            $box.removeClass('loading');
            clearFields();
            return;
        }

        // Use shared helper to avoid duplicated ajax logic
        // Expected resolve: { bank: '...', bic: '...', message?: 'iban_not_found' }
        // Expected reject: any error object/string
        this._fetchBankMetaByIban(ibanNoSpaces)
            .then((d = {}) => {
                $box.removeClass('loading');

                if (d.bank && d.bic) {
                    // Valid hit: fill and lock bankName
                    $bankName.val(d.bank).trigger('change').prop('disabled', true);
                    $errBox.removeClass('-show');

                    this.bankName        = d.bank;
                    this.bankAccountBic  = d.bic;
                    this.bankAccountIban = ibanNoSpaces; // normalized IBAN
                } else {
                    // Not found or incomplete -> allow manual input + show inline error
                    if ((d.message || '').trim() === 'iban_not_found') {
                        $bankName.val('').trigger('change');
                        this.bankName = '';
                        this.bankAccountBic = '';
                        this.bankAccountIban = '';
                    }
                    $bankName.prop('disabled', false);
                    $errBox.addClass('-show');
                }

                this.safeUpdateAutoHeight();
            })
            .catch(() => {
                // Network / backend error -> enable manual input + show error
                $box.removeClass('loading');
                $bankName.prop('disabled', false);
                $errBox.addClass('-show');

                this.safeUpdateAutoHeight();
            });
    }

    // Shallow-merge for flat root, plus shallow merge of 'customer' & 'reading'
    _mergeForPayload(base, overrides) {
        const out = { ...base };

        // root-level known keys
        ['contractNumber','tarifId','section','consumptionPrognosisKwh','bankAccountOwnerName','bankAccountIban','bankName','bankAccountBic','supplyBeginDate','supplyBeginDateSpecified','oldSupplier','oldSupplierCancellationState','supplierOldCancellationDate','booleanAdditional1','booleanAdditional2','marketLocation','deliveryPointMeteringDeviceNumber'].forEach(k => {
            if (overrides[k] !== '' && overrides[k] != null) out[k] = overrides[k];
        });

        // nested: deliveryPointAddress
        if (overrides.deliveryPointAddress) {
            out.deliveryPointAddress = { ...(out.deliveryPointAddress || {}), ...overrides.deliveryPointAddress };
        }
        // nested: customer
        if (overrides.customer) {
            out.customer = { ...(out.customer || {}), ...overrides.customer };
        }
        // nested: reading
        if (overrides.reading) {
            out.reading = { ...(out.reading || {}), ...overrides.reading };
        }

        // drop empties
        Object.keys(out).forEach(k => { if (out[k] === '' || out[k] == null) delete out[k]; });
        return out;
    }

    // Collect just the fields user can change on the form
    _collectFormOverrides() {
        const pay = $(SELECTORS.PAYMENT_TYPE_RADIO_CHECKED).val();
        const keep = $('input[name="keepPaymentMethod"]').is(':checked');

        const customer = {
            // you may add title etc if present on form
            email:     $('[name="email"]').val() || undefined,
            phoneNumber: $('[name="phoneNumber"]').val() || undefined,
            // dateOfBirth/salutation if you let them edit:
            // salutation: $('select[name="salutation"]').val() || undefined,
            // dateOfBirth: this._toISOFromDeOrIso($('[name="dateOfBirth"]').val() || '')
        };

        // Bank: only from form when sepaLastschrift and not keepPaymentMethod
        const owner = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME).val() || '';
        const iban  = (($(SELECTORS.BANK_ACCOUNT_IBAN_INPUT).val() || '').replace(/\s+/g, '')).toUpperCase();
        const bank  = $(SELECTORS.BANK_NAME_INPUT).val() || '';
        const bankBlock = (pay === 'sepaLastschrift' && !keep) ? {
            bankAccountOwnerName: owner || undefined,
            bankAccountIban:      iban  || undefined,
            bankName:             bank  || undefined,
            // BIC не вводиться користувачем — ми вже зберігаємо його в defaultFormData при успішному чекові
        } : {};

        const supply = {};
        supply.supplyBeginDate = this._toISOFromDeOrIso($('[name="supplyBeginDate"]').val());
        supply.supplyBeginDateSpecified = true;

        // Reading (твоя існуюча логіка вже є у FIELD_COMPUTED; дублювати не обов’язково)
        const raw = this._buildPayloadFromMap(); // already collects reading.* if present

        // Delivery point — зазвичай з URL, але якщо щось редагують у формі, можеш підтягнути тут
        const deliveryPointAddress = undefined; // залишаємо базову з defaultFormData

        // Tariff
        const tarifId = this.chosenTariff ? String(this.chosenTariff) : undefined;

        // Email approvals, paymentType flag тощо (твоя `_enrichWithOldRules` потім допише)
        // Тут повертаємо лише те, що користувач точно міняв
        return {
            ...(deliveryPointAddress ? { deliveryPointAddress } : {}),
            ...(Object.values(customer).some(v => v) ? { customer } : {}),
            ...(Object.keys(bankBlock).length ? bankBlock : {}),
            ...(tarifId ? { tarifId } : {}),
            ...(raw?.reading ? { reading: raw.reading } : {}),
            ...(supply || {}),
        };
    }

    // Silent write (no events), but allow normal validation
    _setValueSilently($el, value) {
        // const $wrap = $el.closest('.field-wrap');
        $el.val(value).trigger('change');
        // const $container = $el.closest('.nf-field-container');
        // $container.addClass('active-label label-up');
        // $wrap.removeClass('nf-error nf-pass');  // clean visual state, validation may mark it next
    }

    // Prefill bank inputs from contract/defaults
    prefillBankFieldsFromContract() {
        // Defaults prepared earlier from contract
        const cOwner = this.defaultFormData?.bankAccountOwnerName || this._getFromContractSafe('business.bankData.accountHolder') || '';
        const cIban  = (this.defaultFormData?.bankAccountIban || this._getFromContractSafe('business.bankData.iban') || '').replace(/\s+/g,'').toUpperCase();
        const cBank  = this.defaultFormData?.bankName || this._getFromContractSafe('business.bankData.bankName') || '';
        const cBic   = this.defaultFormData?.bankAccountBic || this._getFromContractSafe('business.bankData.bic') || '';

        const $owner = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME);
        const $iban  = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT);
        const $bank  = $(SELECTORS.BANK_NAME_INPUT);

        // Nothing to prefill = bail out
        if (!$owner.length && !$iban.length && !$bank.length) return;

        // Fill values silently and trigger change for validators/mirroring
        if ($owner.length && cOwner) this._setValueSilently($owner, cOwner);
        if ($iban.length  && cIban)  this._setValueSilently($iban,  cIban);
        if ($bank.length  && cBank)  this._setValueSilently($bank,  cBank);

        // Persist live copies used by payload builder (optimistic with contract first)
        this.bankAccountIban = cIban;
        this.bankName        = cBank;
        this.bankAccountBic  = cBic;

        // Since data comes from contract, bank name should be read-only
        $(SELECTORS.BANK_NAME_INPUT).prop('disabled', true);

        // Clear possible IBAN error boxes
        $(SELECTORS.ERROR_NAME_BANK).removeClass('-show');
        const $wraps = [$owner, $iban, $bank].map($el => $el.closest('.field-wrap'));
        $wraps.forEach($w => $w.removeClass('nf-error iban-api-error'));

        this.safeUpdateAutoHeight();

        // enrich bankName + BIC from backend checker if IBAN is present
        if (cIban) {
            this._fetchBankMetaByIban(cIban).then(meta => {
                if (meta) {
                    // Prefer authoritative values from checker
                    this.bankName       = meta.bank;
                    this.bankAccountBic = meta.bic;

                    if ($bank.length) {
                        this._setValueSilently($bank, meta.bank);
                        $bank.prop('disabled', true); // keep read-only
                    }
                } else {
                    // Keep contract values (already set above)
                }
                this.safeUpdateAutoHeight();
            });
        }
    }

    // Build defaults from contract once and keep them immutable across steps
    seedDefaultFormDataFromContract() {
        const b = this.contractData?.business || {};

        // --- NEW: дістаємо банк-дані з business.bankAccounts[0] із фолбеками ---
        const list = Array.isArray(b.bankAccounts) ? b.bankAccounts : [];
        const primary = list.find(x => x && (x.iban || x.bankName || x.bic || x.ownerName)) || list[0] || {};

        const cOwner = primary.ownerName? (primary.ownerName).trim() : '';
        const cIban  = (primary.iban || b.bankAccountIban || b.bankData?.iban || '')
            .replace(/\s+/g, '').toUpperCase();
        const cBank  = primary.bankName || b.bankData?.bankName || '';
        const cBic   = primary.bic || b.bankData?.bic || '';

        if (!cIban && !cBank && !cBic) {
            this.updateCheckboxes('keepPaymentMethod', false);
        }

        // адреса/клієнт/тощо — як у тебе було
        const deliveryPointAddress = this._buildDeliveryPointAddress();
        const consumption = Number(this.urlParams?.consumption || 0) || 0;

        const dobIso = this._toISODateZ(b.dateOfBirth) || this._toISODateZ(b.originalDateOfBirth);
        const customer = {
            salutation: String(b.salutation || ''),
            firstname : b.firstName || '',
            lastname  : b.name || '',
            email     : (b.newEmail && b.newEmail.trim()) ? b.newEmail : (b.email || ''),
            phoneNumber: (b.phoneNumber || (Array.isArray(b.phoneNumbers) && b.phoneNumbers[0]?.number) || ''),
            dateOfBirth: dobIso || '',
            legalForm : '1',
        };

        const tarifId = (this.tariffId || this.internalTariffId || this.chosenTariff || this.contractData?.tariffId || '') + '';

        const clean = (obj) => {
            const out = {};
            Object.entries(obj || {}).forEach(([k,v]) => { if (v !== '' && v != null) out[k] = v; });
            return out;
        };

        this.defaultFormData = clean({
            deliveryPointAddress,
            customer,
            consumptionPrognosisKwh: consumption ? String(consumption) : '',
            tarifId,
            // --- bank defaults із контракту ---
            bankAccountOwnerName: cOwner,
            bankAccountIban:      cIban,
            bankName:             cBank,
            bankAccountBic:       cBic,
            section: 'Electricity',
        });

        console.log(this.defaultFormData);
    }

    renderForm() {
        // Check contract id as before
        if (!this.contractNumberValue) {
            $(SELECTORS.FORM_WRAPPER).html(
                `<div class="page-title error-token"><h1>Herzlich Willkommen!</h1>
             <div class="text-2"><p>Diese Seite ist nur mit einer gültigen Vertragsnummer zugänglich.</p></div></div>`
            );
            return;
        }

        // New: validate required URL params before anything else
        if (!this.assertUrlParamsOrAbort(this.urlParams)) return;

        this.getContractInfo()
            .then(ContractData => {
                const oldTariffId = (ContractData && ContractData.tariffId) || '';
                this.seedDefaultFormDataFromContract();
                return this.fetchAllowedTariffs(oldTariffId);
            })
            .then(() => this.preloadPriceInfoFromUrl())
            .then(() => this.getContractAdditionalInfo())
            .then((additional) => {
                // Apply effects (possibly remove consent UI) BEFORE validation
                this.applyContractAdditionalEffects(additional);
            })
            .then(() => {
                if (this._abort) return;
                this.initSwiper();
                return this.initializeForm();
            })
            .then(() => this.initBankFieldHandlers())
            .then(() => this.initPromocodeHandlers())
            .then(() => this.fillCustomerSummary())
            .then(() => this.fillAddressSummary())
            .then(() => this.updateSummaryAll())
            .then(() => {
                if (this._abort) return;

                this.hideLoader();
                this.loading = false;
            })
            .then(() => {
                if (!this._abort) {
                    this.validateForm();
                }
            })
            .then(() => this.prefillBankFieldsFromContract())
            .catch(error => {
                this.hideLoader();
                this.loading = false;
                console.error('Failed to render form:', error);
                $(SELECTORS.FORM_WRAPPER).html(
                    `<div class="page-title error-token">
                            <h1>Leider haben wir Deinen Vertrag mit der Vertragsnummer nicht in unserem System gefunden. Bitte wende Dich an den Kundenservice.</h1>
                            </div>`
                );
            });
    }


    // Replace your current createSendData() with this version
    createSendData() {
        if (!this.contractNumberValue) {
            console.error('contractNumber is missing.');
            this.loading = false;
            return Promise.reject('contractNumber is missing');
        }

        try {
            // 1) Start from immutable defaults
            const base = { ...(this.defaultFormData || {}) };

            // 2) Apply minimal overrides collected from the form
            const overrides = this._collectFormOverrides();
            let payload = this._mergeForPayload(base, overrides);

            // 3) Enforce your old rules (will set flags/booleans/dates etc.)
            this._enrichWithOldRules(payload);

            const payNow = $(SELECTORS.PAYMENT_TYPE_RADIO_CHECKED).val();
            if (payNow === 'rechnung') {
                delete payload.bankAccountOwnerName;
                delete payload.bankAccountIban;
                delete payload.bankName;
                delete payload.bankAccountBic;
            }

            // 4) If raw supply dates exist from FIELD_MAP, normalize (kept from your logic)
            const raw = this._buildPayloadFromMap();
            if (raw?.supply?.beginDate) {
                payload.supplyBeginDate = this._toISOFromDeOrIso(raw.supply.beginDate);
                if (payload.supplyBeginDate) {
                    payload.supplyBeginDateSpecified = true;
                }
            }

            // 5) Banking: if user did not switch to form values, keep defaults (already merged above)
            // Ensure we don't lose BIC (either from defaultFormData or post-IBAN-check)
            // Nothing else needed here since merge preserved bankAccountBic

            // 6) Final cleanup
            delete payload.riskClass;
            Object.keys(payload).forEach(k => {
                if (payload[k] === '' || payload[k] == null) delete payload[k];
            });

            return Promise.resolve(payload);
        } catch (e) {
            this.loading = false;
            return Promise.reject(e?.message || 'Failed to build payload');
        }
    }

    buildSupplyEndPayload() {
        const contractNumber = this.contractNumberValue;

        const rawEnd = ($('[name="supplyEndDate"]').val() || '').trim();
        const supplyEndDate = this._toISOFromDeOrIso(rawEnd) || new Date().toISOString();

        return {
            contractNumber: String(contractNumber || ''),
            inboxDate: new Date().toISOString(),
            supplyEndDate,
            supplyEndReason: 'UMZUG'
        };
    }

    async sendFinishAcquisition(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${this.proxyUrl}?type=finishAcquisition`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => resolve(response),
                error: (xhr, status, error) => {
                    const html = (xhr && xhr.responseText || '').trim();
                    console.error('finishAcquisition error:', error, html);
                    reject('Leider ist etwas schiefgelaufen. Bitte versuche es erneut.');
                }
            });
        });
    }

    async sendSupplyEnd(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${this.proxyUrl}?type=supplyEnd`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (res) => resolve(res),
                error: (xhr, status, error) => {
                    const html = (xhr && xhr.responseText || '').trim();
                    console.error('supplyEnd error:', error, html);
                    reject('Dein aktueller Vertrag ist noch nicht in Belieferung und kann nicht gekündigt werden');
                }
            });
        });
    }

    sendBusinessPartnerNumberAsPromise(requestData) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${this.proxyUrl}?type=sendBusinessPartnerNumber`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(requestData),
                success(response) {
                    resolve(response);
                },
                error(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX error: ' + textStatus + ' - ' + errorThrown);
                    reject(new Error('AJAX error: ' + textStatus + ' - ' + errorThrown));
                }
            });
        });
    }

    showSuccessMessage() {
        const wrapper = $(SELECTORS.FORM_CONTAINER);
        const successLink = umzug.success_page || '';
        const html = `<div class="success-message">
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="204" height="204" viewBox="0 0 204 204" fill="none">
                                <mask id="path-1-inside-1_24622_46755" fill="white">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 102C2 137.727 21.0599 170.739 52 188.603C82.9401 206.466 121.06 206.466 152 188.603C182.94 170.739 202 137.727 202 102C202 66.2734 182.94 33.2607 152 15.3975C121.06 -2.46582 82.9401 -2.46582 52 15.3975C21.0599 33.2607 2 66.2734 2 102"/>
                                </mask>
                                <path d="M6 102C6 99.7909 4.20914 98 2 98C-0.209139 98 -2 99.7909 -2 102H6ZM202 102H198H202ZM-2 102C-2 104.209 -0.209139 106 2 106C4.20914 106 6 104.209 6 102H-2ZM2 102H-2C-2 139.156 17.8223 173.489 50 192.067L52 188.603L54 185.138C24.2975 167.99 6 136.297 6 102H2ZM52 188.603L50 192.067C82.1777 210.644 121.822 210.644 154 192.067L152 188.603L150 185.138C120.298 202.287 83.7025 202.287 54 185.138L52 188.603ZM152 188.603L154 192.067C186.178 173.489 206 139.156 206 102H202H198C198 136.297 179.702 167.99 150 185.138L152 188.603ZM202 102H206C206 64.8444 186.178 30.5112 154 11.9334L152 15.3975L150 18.8616C179.702 36.0103 198 67.7025 198 102H202ZM152 15.3975L154 11.9334C121.822 -6.64445 82.1777 -6.64445 50 11.9334L52 15.3975L54 18.8616C83.7025 1.71281 120.298 1.71281 150 18.8616L152 15.3975ZM52 15.3975L50 11.9334C17.8223 30.5112 -2 64.8444 -2 102H2H6C6 67.7025 24.2975 36.0103 54 18.8616L52 15.3975Z" fill="#FF380E" mask="url(#path-1-inside-1_24622_46755)"/>
                                <path d="M68.6641 102L90.8863 124.222" stroke="#FF380E" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M90.8906 124.222L135.335 79.7773" stroke="#FF380E" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <h3>Geschafft! Danke, dass wir mit Dir umziehen dürfen.</h3>
                        <div class="text-3">Wir leiten jetzt alles in die Wege, damit Du pünktlich zum Einzug weiterhin Deinen grüüün Strom erhältst. Für alle weiteren Schritte melden wir uns per E-Mail bei Dir.</div>
                        ${successLink? `<div class="btn-box"><a href="${successLink}" class="button-kundenportal">Fertig</a></div>`:''}
                    </div>`;

        wrapper.html(html);

        this.scrollIntoView(wrapper);
    }

    async handleFormSubmit(event) {
        event.preventDefault();
        if (this.loading || this.wasSendToApi) return;

        this.loading = true;

        if (this.swiper && !this.validateInputsOnSlide(this.swiper.activeIndex)) {
            this.loading = false;
            return;
        }

        try {
            let contractState = await this.getContractState();
            console.log(contractState);

            if(contractState === 'CANCELED' || contractState === 'ENDED') {
                $(SELECTORS.API_ERROR_MESSAGE).html('Dein Vertrag ist bereits gekündigt und Du kannst nicht mit diesem Umziehen. Bitte schließe einen neuen Vertrag über die Webseite ab.');
                this.scrollIntoView($(SELECTORS.API_ERROR_MESSAGE));
                $(SELECTORS.SUBMIT_BUTTON).removeClass('-loading');
                this.safeUpdateAutoHeight?.();
                this.loading = false;
                return;
            } else if(contractState !== 'GPKE_APPROVED') {
                $(SELECTORS.API_ERROR_MESSAGE).html('Dein aktueller Vertrag ist noch nicht in Belieferung und kann nicht gekündigt werden.');
                this.scrollIntoView($(SELECTORS.API_ERROR_MESSAGE));
                $(SELECTORS.SUBMIT_BUTTON).removeClass('-loading');
                this.safeUpdateAutoHeight?.();
                this.loading = false;
                return;
            }
        } catch (err) {
            $(SELECTORS.API_ERROR_MESSAGE).html('Leider ist etwas schiefgelaufen. Bitte versuche es erneut.');
            this.scrollIntoView($(SELECTORS.API_ERROR_MESSAGE));
            $(SELECTORS.SUBMIT_BUTTON).removeClass('-loading');
            this.safeUpdateAutoHeight?.();
            this.loading = false;
            return;
        }


        this.createSendData()
            .then(async (payload) => {
                console.log(payload);

                this.wasSendToApi = true;

                // 1) supplyEnd — must succeed
                const supplyEndPayload = this.buildSupplyEndPayload();
                console.log(supplyEndPayload);
                await this.sendSupplyEnd(supplyEndPayload);


                // 2) finishAcquisition
                const finishRes = await this.sendFinishAcquisition(payload);
                console.log(finishRes);

                // 3) sendBusinessPartnerNumberAsPromise — do not skip this step
                try {
                    const businessPartnerNumber = finishRes?.businessPartnerNumber || finishRes;
                    const businessPartnerPayload = {
                        businessNumber: businessPartnerNumber,
                        isAgreement: payload?.booleanAdditional2
                    }
                    console.log(businessPartnerPayload);
                    await this.sendBusinessPartnerNumberAsPromise(businessPartnerPayload);
                } catch (err) {
                    console.error('Business partner flow error:', err);
                }

                // 4) success message
                this.showSuccessMessage();

            })
            .catch((err) => {
                console.error('Submit chain error:', err);
                this.wasSendToApi = false;
                $(SELECTORS.API_ERROR_MESSAGE).html('Leider ist etwas schiefgelaufen. Bitte versuche es erneut.');
                this.scrollIntoView($(SELECTORS.API_ERROR_MESSAGE));
                $(SELECTORS.SUBMIT_BUTTON).removeClass('-loading');
                this.safeUpdateAutoHeight?.();
            })
            .finally(() => {
                this.loading = false;
            });
    }
}

// Initialize Umzug API service
const umzugApiService = new UmzugApiService();

$(document).on('change', SELECTORS.SWITCHER_RADIO, (e) => {
    umzugApiService.showHiddenFields();
    umzugApiService.hideTriggeredFields();

    setTimeout(function () {
        if ($(SWIPER.CONTAINER).length > 0) {
            umzugApiService.swiper.updateAutoHeight();
        }
    }, 10);
});

$(document).on('keydown', function(e) {
    if (e.key === 'Tab') {
        const $current = $(':focus');

        if ($current.hasClass('button-next')) {
            e.preventDefault();
        }
    }
});

